import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { UserStatusService } from '../../Services/user-status.service';
import { ActivatedRoute } from "@angular/router";
import { Configuration } from "../../config/config";
import { courses } from "../../models/courses";
import { TranslateService } from "@ngx-translate/core";
import {AssessmentModel} from "../../models/assessment.model";
import {questionModel} from "../../models/questionModel";
import Player from "@vimeo/player";
import { GlobalService } from "../../Services/global.service";
import {HttpErrorService} from "../../Services/http-error.service";
declare let $;

@Component({
  selector: 'app-content-launcher',
  templateUrl: './content-launcher.component.html',
  styleUrls: ['./content-launcher.component.css'],
  providers: [UserStatusService]
})
export class ContentLauncherComponent implements OnInit {
  @ViewChild('TabVideoPlayer') TabVideoPlayer: ElementRef;
  @ViewChild('videoPlayer') videoplayer: any;
  @ViewChild('vdoTrack1') videoTrack1: any;
  @ViewChild('vdoTrack1') videoTrack2: any;
  @ViewChild('crsVdoTrack1') crsVideoTrack1: any;
  @ViewChild('crsVdoTrack2') crsVideoTrack2: any;
  @ViewChild('vimeoVideo') vimeoVideo;
  @ViewChild('vimeoCertVideo') vimeoCertVideo;
  @ViewChild('coursevideoPlayer') courseVideoPlayer: any;

  gameTranTitle: any;
  gameJsonData;
  nameOfGame = '';
  nameOfGameFolder = '';
  gameLanguage;
  gameUrl : string = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames;
  characterSpeech;
  influence: any;
  master_feedback: any;
  charactersDetails: any;
  general_feedback: Array<any> = [];
  sceneCharacters: any;
  currentSceneAudios;
  allCurrentPlayingAudio: Array<any> = [];
  reactions: any;
  noGameFileStatus;
  reviewMode: boolean = false;
  generalFeedbackDesktop: boolean = true;
  isGameRestart: boolean = false;
  game_type;
  selectedScene: any;
  isCertificateGame: boolean = false;
  currentFeedbackAudio: any;
  percent = 0;
  volume = 0.5;
  advGameFinished: boolean = false;
  modalFooterLeftSection: boolean = true;
  showButton: boolean = true;
  currentPlayingStep: any;
  notificationDiv: boolean = true;
  startGameScreen = false;
  oldGameURL: string;
  userID;
  course: courses = new courses();
  videoPath;
  engVideoPath;
  community_id = '';
  certificate_id: string = '';
  reviewOutput: Array<any> = [];
  reviewStatus: boolean = false;
  choice: string = "";
  gameAdvUrl: any;
  selectedGameResponse: string;
  communityID;
  publishGameData: any;
  lastSelectedPath: any;
  gameFinishedData;
  lastSelectedGameResponse: string = '';
  course_id: any;
  certificationStep: any;
  lastScore: Array<number> = [];
  scorePrevData: Array<number> = [];
  characterSpeechAdv;
  count: number = 0;
  link_type: string = '';
  link_id: string = '';
  rule: string = '';
  gameId: string = '';
  assessmentId: string = '';
  videoId: string = '';
  guestStatus : string = "";
  currentCertificate: any;
  sceneInfoCharacters;
  /************* Assessment ***********/
  noAnswers: boolean = false;
  invalidAnswers: boolean = false;
  finalAswers = [];
  finalResultArray = [];
  submitAssessmentBtn: boolean = false;
  nextAssessmentBtn: boolean = false;
  resultContainer: boolean = false;
  progressData: Array<any> = [];
  answers = [];
  validationMsg: string = "";
  passing_score: string = "";
  finalScore: string = "";
  progressScore: number = 0;
  assessment: AssessmentModel = new AssessmentModel();
  isSurveyGiven: boolean = false;
  questionsArr: Array<questionModel> = [];
  minimumPassScore: string = '';
  step_unique_id: string = '';
  step_id: string = '';
  checkInit: number = 0;
  played_steps = [];
  index = 0;
  currentStep: string = '';
  currentStepType: string = '';
  isShowAssErr : boolean = false;

  /*****************Video*******************/
  selectedVideo;
  certPlayerFlag: boolean = false;
  player: YT.Player;
  certificatePlayer: YT.Player;
  youtubePlayerFlag: boolean = true;
  vimeoPlayerFlag: boolean = true;
  vimeoPlayer: Player;
  vimeoCertPlayer: Player;
  options = {};
  coursePlayerFlag: boolean = false;
  currentTime;
  duration;
  courseVideoId = '';
  certificateVideoId = '';
  videoSource: any;
  videoSrtPath: any;
  videoEngSrtPath: any;

  visibleProgess: boolean = false;
  progressValue: number = 0;
  callbackUrl: string = '';
  returnData;
  redirectUrl: string = '';
  isResourceBtn: boolean = false;
  addLearnObjText: String = '';
  screenWidth: number = 1366;
  influenceCounter: number = 0;
  dummyinfluenceCounter: number = 0;
  lastThreeResponse: string = "";
  dummylastThreeResponse: string = "";
  preloadNextSceneSprites: any;
  isSpriteAnimationLoaded: boolean = false;
  randomNumber: number;
  languageAudioList: Array<any> = [];
  englishAudioList: Array<any> = [];
  disableGameResponse: any = 'true';
  loadedAudios: any;
  screenHeight: number;
  loaderText: string = 'game';
  resConfig : Array<any> = [];
  usrGameCfgData: Array<any> = [];
  no_of_attempts : number = 0;
  tryOtherAnsCFGFlag: boolean = false;
  keyLearningCFGFlag: boolean = false;
  keyLearningBlinkFlag: boolean = false;
  addExtraPoints: number = 0;
  gameIconList: Array<String> = [];
  orientation: any;
  isDisplayNotificationDiv: boolean = false;

  constructor(private userStatusService:UserStatusService,private activatedRoute: ActivatedRoute,private translate: TranslateService,private GlobalService: GlobalService,
  private httpErrorService: HttpErrorService) {
    this.translate.reloadLang('English');
  }

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
      $("#extrnalCssFile").attr("href", '');
    });
    this.translate.setDefaultLang('English');
    this.screenWidth = screen.width || window.screen.width;
    this.screenHeight = screen.height || window.screen.height;

    window.addEventListener("orientationchange", () => {
      // Announce the new orientation number
      this.orientation = window.orientation;
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      } else {
        this.screenWidth = screen.width || window.screen.width;
        this.screenHeight = screen.height || window.screen.height;
      }
    });
    const username = this.activatedRoute.snapshot.paramMap.get('token');
    const comm_id = this.activatedRoute.snapshot.paramMap.get('comm_id');
    window.name = comm_id;
    let token = username;
    $("#preloader").css('display', 'block');
    this.userStatusService.getJWTToken(token,comm_id).subscribe(res =>{
      if(res.success){
        this.userStatusService.getCommunityNameByCommunityID(comm_id).subscribe(comm=> {
          if(comm.data){
            let commResObj = {
              community_id: comm.data.comm_id,
              community_name: comm.data.comm_name,
              resource_config: comm.data.resource_config
            };
            localStorage.setItem('CommResources', JSON.stringify(commResObj));
            console.log(commResObj);
            sessionStorage.setItem('UserData', JSON.stringify(res.data));
            this.userStatusService.jwtToken = res.token;
            localStorage.setItem('currentUser', JSON.stringify({token: res.token}));
            this.userID = res.data.user_id;
            this.communityID = res.data.communityId;
            this.callbackUrl = res.data.returnEndpoint;
            this.returnData = res.data.returnData;
            this.redirectUrl = res.data.returnUrl;
            this.translate.reloadLang('English');
            if(res.data.type == "Game"){
              this.gameId = res.data.id;
              let obj = {
                game_id: res.data.id,
                user_id: this.userID,
                commId: this.communityID,
                userRole: res.data.userrole
              };
              this.userStatusService.validateGameContentLauncher(obj).subscribe(res =>{
                $("#preloader").css('display', 'none');
                if(res.success && res.statusCode == '200'){
                  this.publishGameData = res.data;
                  this.isCertificateGame = res.type == 'Certification' ? true: false;
                  this.course_id = res.course_id;
                  this.certificationStep = res.gameCertData;
                  this.currentCertificate = res.certification;
                  this.no_of_attempts = res.attempts;
                  let gmObj = {
                    user_id: this.userID,
                    commId: this.communityID,
                    gameId: this.gameId,
                    course_id: this.course_id,
                    certId: this.currentCertificate
                  };
                  this.translate.get(['LEARNER_TAB.SCREEN_ROTATE_MSG', 'LEARNER_TAB.GAME_LOADER', 'LEARNER_TAB.INTRODUCTION_TAB', 'LEARNER_TAB.VIDEO_NOT_SUPPORTED', 'LEARNER_TAB.INSTRUCTION_TAB', 'LEARNER_TAB.RESOURCE_TAB', 'LEARNER_TAB.GEN_FEED_TAB', 'LEARNER_TAB.VIDEO_NOT_SUPPORTED', 'BUTTON_TITLE.RESOURCES','BUTTON_TITLE.VOLUME', 'BUTTON_TITLE.INSTRUCTION', 'BUTTON_TITLE.INTRODUCTION', 'BUTTON_TITLE.LEARNING_OBJECTIVE','SERVER_HTTP_ALERT.SPRITE_ANIMATIONS', 'LEARNER_TAB.SPRITE_LOADER', 'LEARNER_TAB.AUDIO_LOADER']).subscribe(label => {
                    this.gameTranTitle = label;
                  });
                  if(this.userID && this.communityID && this.gameId){
                    this.userStatusService.getUserGameDetails(this.userID, this.communityID, this.gameId).subscribe(det=>{
                      if(det.success){
                        this.usrGameCfgData = det.data && det.data.details && det.data.details.length > 0 ? det.data.details : [];
                      }else{
                        this.usrGameCfgData = [];
                      }
                      this.userStatusService.getGameAttempts(gmObj).subscribe(gmAtm=>{
                        if(gmAtm.success){
                          this.no_of_attempts = gmAtm.data;
                        }else{
                          this.no_of_attempts = 0;
                        }
                      });
                    });
                  }else{
                    this.usrGameCfgData = [];
                    this.no_of_attempts = 0;
                  }
                  let certobj = {};
                  if(res.type == 'Certification'){
                    certobj = {
                      "user_id": this.userID,
                      "certificate_id": this.currentCertificate.certificate_id,
                      "type_flag": "certificate",
                      "course_id": this.course_id,
                      "status": "Inprogress",
                      "version": this.currentCertificate.version,
                      "community_id": this.communityID
                    };
                    this.userStatusService.updateLearnerTransaction(certobj).subscribe(res=>{

                    });
                  }
                  this.playCourseGame(res.data, res.data.level);
                } else if (res.statusCode == '202'){
                  this.guestStatus = '202';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '203'){
                  this.guestStatus = '203';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '204'){
                  this.guestStatus = '204';
                  $('#alertMsgsModel').modal('show');
                }else if (res.statusCode == '211'){
                  this.guestStatus = '211';
                  $('#alertMsgsModel').modal('show');
                }
              });
            }
            else if(res.data.type == "Assessment"){
              let assessmentId = res.data.id;
              let obj = {
                assessment_id: res.data.id,
                user_id: this.userID,
                commId: this.communityID,
                userRole: res.data.userrole
              };
              this.userStatusService.validateAssessmentContentLauncher(obj).subscribe(res=>{
                $("#preloader").css('display', 'none');
                if(res.success && res.statusCode == '200'){
                  this.certificationStep = res.gameCertData;
                  this.currentCertificate = res.certification;
                  this.course_id = res.course_id;
                  this.certificate_id = res.certification.certificate_id;
                  let obj = {};
                  if(res.type == 'Certification'){
                    obj = {
                      "user_id": this.userID,
                      "certificate_id": this.currentCertificate.certificate_id,
                      "type_flag": "certificate",
                      "course_id": this.course_id,
                      "status": "Inprogress",
                      "version": this.currentCertificate.version,
                      "community_id": this.communityID
                    };
                    this.userStatusService.updateLearnerTransaction(obj).subscribe(res=>{});
                  }
                  this.viewAssessment(res.gameCertData);
                } else if (res.statusCode == '202'){
                  this.guestStatus = '202';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '203'){
                  this.guestStatus = '203';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '204'){
                  this.guestStatus = '204';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '206') {
                  this.guestStatus = '206';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '207') {
                  this.guestStatus = '207';
                  $('#alertMsgsModel').modal('show');
                }else if (res.statusCode == '211'){
                  this.guestStatus = '211';
                  $('#alertMsgsModel').modal('show');
                }
              });
            }
            else if(res.data.type == "Video"){
              let videoId = res.data.id;
              let obj = {
                video_id: res.data.id,
                user_id: this.userID,
                commId: this.communityID,
                userRole: res.data.userrole
              };
              this.userStatusService.validateVideoContentLauncher(obj).subscribe(res=>{
                $("#preloader").css('display', 'none');
                if(res.success && res.statusCode == '200'){
                  this.certificationStep = res.gameCertData;
                  this.currentCertificate = res.certification;
                  this.course_id = res.course_id;
                  let obj = {};
                  if(res.type == 'Certification'){
                    this.certificate_id = res.certification.certificate_id;
                    obj = {
                      "user_id": this.userID,
                      "certificate_id": this.currentCertificate.certificate_id,
                      "type_flag": "certificate",
                      "course_id": this.course_id,
                      "status": "Inprogress",
                      "version": this.currentCertificate.version,
                      "community_id": this.communityID
                    };
                    this.userStatusService.updateLearnerTransaction(obj).subscribe(res=>{});
                    this.playVideo(res.gameCertData);
                  } else if(res.type == 'Course'){
                    this.playCourseVideo(videoId);
                  }
                } else if (res.statusCode == '202'){
                  this.guestStatus = '202';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '203'){
                  this.guestStatus = '203';
                  $('#alertMsgsModel').modal('show');
                } else if (res.statusCode == '204'){
                  this.guestStatus = '204';
                  $('#alertMsgsModel').modal('show');
                }
              });
            }
          }
        });
      } else {
        $("#preloader").css('display', 'none');
        if(res.statusCode == 'no-token'){
          this.guestStatus = '208';
          $('#alertMsgsModel').modal('show');
        }else if(res.statusCode == '202'){
          this.guestStatus = '209';
          $('#alertMsgsModel').modal('show');
        }else if(res.statusCode == '203'){
          this.guestStatus = '210';
          $('#alertMsgsModel').modal('show');
        }else if (res.statusCode == '211'){
          this.guestStatus = '211';
          $('#alertMsgsModel').modal('show');
        }else{
          this.guestStatus = '201';
          $('#alertMsgsModel').modal('show');
        }
      }
    });
  }

  userInteractBtnClick(){
    console.log("Clicked...");
  }

  playCourseGame(game, level) {
    this.screenWidth = screen.width || window.screen.width;
    this.lastSelectedGameResponse = "";
    let num = this.generateRandomNumber(0,101);
    this.randomNumber = num > 70 ? 2 : 1;
    if(localStorage.getItem('Volume')){
      this.volume = parseFloat(localStorage.getItem('Volume'));
    } else {
      this.volume = 0.5;
      localStorage.setItem('Volume', '0.5');
    }
    if(this.volume == 0){
      $(".volumeOn").addClass("displayNone");
      $(".volumeOff").removeClass("displayNone");
    } else {
      $(".volumeOn").removeClass("displayNone");
      $(".volumeOff").addClass("displayNone");
    }
    this.progressStart();
    this.currentPlayingStep = game;
    $('.playIconBtn').removeClass('displayNone');
    $('.pauseIconBtn').addClass('displayNone');
    let published_game = game.published_game.split('.')[0];
    this.nameOfGame = published_game;
    this.userStatusService.getResourceConfiguration(this.communityID).subscribe(rcData => {
      if(rcData.success){
        let commId = this.communityID;
        this.resConfig = rcData.data && rcData.data.resource_config && rcData.data.resource_config.length > 0 ? rcData.data.resource_config : [];
        if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Style && this.resConfig[0].Style.visible){
          let link = Configuration.S3_BucketObjectURL + Configuration.S3_CommonResources + commId + '/' + Configuration.S3_StylesPath + 'gameStyle.css';
          console.log(link);
          $("#extrnalCssFile").attr("type", "text/css");
          $("#extrnalCssFile").attr("href", link);
          this.gameIconList = rcData.iconList;
          this.getGameIcons();
        }else{
          $("#extrnalCssFile").attr("href", '');
          this.gameIconList = [];
        }
      }else{
        this.resConfig = [];
        this.gameIconList = [];
        $("#extrnalCssFile").attr("href", '');
      }
      this.userStatusService.getGameJsonData(published_game, 'information', 'English', {}).subscribe(gameData => {
        if (gameData.success) {
          this.nameOfGameFolder = gameData.gameName;
          this.gameLanguage = gameData.language;
          this.languageAudioList = gameData.audioList;
          this.englishAudioList = gameData.englishAudioList;
          this.videoPath = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + published_game + "/" + this.gameLanguage + "/videos/";
          this.engVideoPath = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + published_game + "/English/videos/";
          if (gameData.game_type == "oldGame") {
            $("#flashPlayerpreloader").css('display', 'block');
            this.oldGameURL = gameData.path;
            $('#oldGameModal').modal('show');
          } else {
            this.noGameFileStatus = '';
            let game = gameData.data;
            this.gameJsonData = JSON.parse(JSON.stringify({ game }));
            if(this.gameJsonData.game.information.resource && this.gameJsonData.game.information.resource.length > 0){
              this.isResourceBtn = false;
            }else{
              this.isResourceBtn = true;
            }

            this.addLearnObjText = '';
            if(this.gameJsonData.game.information.learnObjective && this.gameJsonData.game.information.learnObjective.length > 0){
              this.addLearnObjText = this.gameJsonData.game.information.learnObjective;
            }

            window.addEventListener("orientationchange", () => {
              // Announce the new orientation number
              this.orientation = window.orientation;
              if (this.orientation == 90) {
                $('.portraitView').hide();
                $('.landscapeView').show();
                $('.showSingle').removeClass('modalFooterActiveBtn');
                $('#showSingle0').addClass('modalFooterActiveBtn');
                $('.targetDiv').hide();
                $('.startGameScreen').hide();
                $('#section0').show();
                this.startGameScreen = false;
                this.isDisplayNotificationDiv = false;
                this.notificationDiv = true;
                this.modalFooterLeftSection = true;
                this.showButton = true;
                this.reviewMode = false;
                this.advGameFinished = false;
              } else {
                $('.portraitView').show();
                $('.landscapeView').hide();
                this.startGameScreen = false;
              }
            });

            var mobLandscapeView = document.getElementById('mobLandscapeView');
            var timeout;
            var lastTap = 0;
            let that = this;
            mobLandscapeView.addEventListener('touchend', function(event) {
              var currentTime = new Date().getTime();
              var tapLength = currentTime - lastTap;
              let dblFlag = false;
              clearTimeout(timeout);
              if(that.screenWidth < 1000) {
                if (tapLength < 500 && tapLength > 1) {
                  dblFlag = true;
                  if (($(".mobileSlideHeader").hasClass("headerShow"))) {
                    $(".mobileSlideHeader").toggleClass("headerShow");
                    $('.commonModalFooter').css({"display": "none"});
                    $('.gameContainer').css('height', '100vh');
                    $('.instructionModalContainer').css('height', '100vh');
                  } else {
                    $(".mobileSlideHeader").toggleClass("headerShow");
                    $('.commonModalFooter').css({"display": "flex"});
                    $('.gameContainer').css('height', 'calc(100vh - 116px)');
                    $('.instructionModalContainer').css('height', 'calc(100vh - 116px)');
                  }
                  event.preventDefault();
                } else {
                  timeout = setTimeout(function () {
                    if (!dblFlag) {
                      that.topAndBottomBarHide();
                    }
                    clearTimeout(timeout);
                  }, 500);
                }
              }
              lastTap = currentTime;
            });

            if (window.innerHeight > window.innerWidth) {
              $('.portraitView').show();
              $('.landscapeView').hide();
              this.startGameScreen = false;
            } else {
              $('.portraitView').hide();
              $('.landscapeView').show();
              $('.showSingle').removeClass('modalFooterActiveBtn');
              $('#showSingle0').addClass('modalFooterActiveBtn');
              $('.targetDiv').hide();
              $('.startGameScreen').hide();
              $('#section0').show();
              this.getGameIcons();
              this.startGameScreen = false;
              this.isDisplayNotificationDiv = false;
              this.notificationDiv = true;
              this.modalFooterLeftSection = true;
              this.showButton = true;
              this.reviewMode = false;
              this.advGameFinished = false;
            }
            this.sceneCharacters = {};
            let game_type = '';
            let sceneName = '';
            if(this.gameJsonData.game.Scene) {
              game_type = "Basic";
              sceneName = 'Scene';
            } else {
              game_type = "Advance";
              sceneName = this.randomNumber.toString();
            }
            let totalFiles = [];
            let files = [];
            if (game_type == "Basic") {
              files = this.getAllAudioFileData('instruction', 'Basic');
              totalFiles = totalFiles.concat(files);
              files = this.getAllAudioFileData('information', 'Basic');
              totalFiles = totalFiles.concat(files);
              let image = new Image();
              if(this.gameJsonData.game.Scene.backGroundImage){
                image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.gameJsonData.game.Scene.backGroundImage;
              } else {
                image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
              }
            } else {
              files = this.getAllAudioFileData('instruction', 'Advance');
              totalFiles = totalFiles.concat(files);
              files = this.getAllAudioFileData('information', 'Advance');
              totalFiles = totalFiles.concat(files);
              let image = new Image();
              image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameJsonData.game.scenarios.scenario.sceneBg;
            }
            files = this.getAllAudioFileData(sceneName, game_type);
            totalFiles = totalFiles.concat(files);
            this.loadSpriteAnimations(sceneName, this.nameOfGame, game_type, (sceneCharacters)=>{
              this.loadGivenAudios(totalFiles,(loadedAudios)=> {
                this.disableGameResponse = 'true';
                this.currentSceneAudios = loadedAudios;
                this.loadedAudios = loadedAudios;
                this.charactersDetails = this.gameJsonData.game.information;
                this.general_feedback = this.gameJsonData.game.learning;
                this.sceneCharacters = $.extend(this.sceneCharacters, sceneCharacters);
                this.getGameIcons();
                this.playIntroAudio();
              });
            });
            this.progressValue = 0;
            $('#coursegameInfoModal').modal('show');
            this.loaderText = 'game';
            $("#preloaderModal").css('display', 'block');
            let currentBrowserName: string = this.GlobalService.getCurrentBrowserName();
            if(currentBrowserName === 'Chrome' || currentBrowserName === "Chromium" || currentBrowserName === "Safari") {}
            else {
              $('#browserDetectionModal').modal('show');
            }
          }
        } else {
          this.noGameFileStatus = '201';
          $('#noGameFilesModal').modal('show');
        }
      });
    });
  }

  getGameIcons(){
    let icons = [
      {
        id: 'showSingle0',
        icon: 'introduction'
      },
      {
        id: 'showSingle1',
        icon: 'instruction'
      },
      {
        id: 'showSingle2',
        icon: 'resource'
      },
      {
        id: 'showSingle3',
        icon: 'keyLearn'
      },
      {
        id: 'showSingle4',
        icon: 'reviewChoice'
      },
      {
        id: 'showSingle5',
        icon: 'score'
      },
      {
        id: 'showSingle6',
        icon: 'score'
      },
      {
        id: 'showSingle10',
        icon: 'learnObjective-icon'
      },
      {
        id: 'volumeOnIcon',
        icon: 'volumeOn'
      },
      {
        id: 'volumeOffIcon',
        icon: 'volumeOff'
      }
    ];

    if(this.gameIconList && this.gameIconList.length > 0){
      for (let a = 0; a < this.gameIconList.length; a++) {
        let name = this.gameIconList[a].split('.')[0];
        let ind = icons.findIndex(obj=> obj.icon == name);
        if(ind > -1){
          let fileName = this.gameIconList[a];
          let commId = this.communityID;
          if(icons[ind].id.includes('volume')){
            let id = '.' + icons[ind].id;
            let src = Configuration.S3_BucketObjectURL + Configuration.S3_CommonResources + commId + '/' + Configuration.S3_StylesPath + Configuration.S3_IconsPath + fileName;
            $(document).ready(function() {
              $( id ).each(function() {
                $( this ).attr( "src" , "" );
                $( this ).attr( "src" , src );
              });
            });
          }else{
            let id = '.'+ icons[ind].id;
            let src = Configuration.S3_BucketObjectURL + Configuration.S3_CommonResources + commId + '/' + Configuration.S3_StylesPath + Configuration.S3_IconsPath + fileName;
            $(id).attr('src', '');
            $(id).attr('src', src);
          }
        }
      }
    }
  }

  playIntroAudio() {
    this.startGameOnLoadData();
    if (this.charactersDetails.introduction.fileType == 'audio'){
      this.playAudio(this.charactersDetails.introduction.fileName)
    } else {
      if (this.charactersDetails.introduction.fileType == 'video') {
        if(document.readyState === "complete") {
          // Fully loaded!
          if ($(".introTabVideoPlayer").get(0)) {
            $(".introTabVideoPlayer").get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
            document.getElementById("userInteractBtn").click();
            $(".introTabVideoPlayer").get(0).play();
            $(".introTabVideoPlayer").get(0).currentTime = 0;
          }
        }else{
          $(document).ready(function(){
            if ($(".introTabVideoPlayer").get(0)) {
              $(".introTabVideoPlayer").get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
              document.getElementById("userInteractBtn").click();
              $(".introTabVideoPlayer").get(0).play();
              $(".introTabVideoPlayer").get(0).currentTime = 0;
            }
          });
        }
      }
    }
  }

  topAndBottomBarHide(){
    var ts;
    let that = this;
    $(document).on("touchstart", (e) => {
      ts = e.originalEvent.touches[0].clientY;
    });
    $(document).on("touchend", (e) => {
      var te = e.originalEvent.changedTouches[0].clientY;
      if(that.screenWidth < 1000) {
        if (ts > te + 5) {
          //Slide Up to Show
          $(".mobileSlideHeader").removeClass("headerShow");
          $(".instructionModalContainer").css('height', 'calc(100vh - 66px)');
          $('.commonModalFooter').css('display', 'flex');
          $('.gameContainer').css('height', 'calc(100vh - 66px)');
        } else if (ts < te - 5) {
          //Slide Down to Hide
          $(".mobileSlideHeader").addClass("headerShow");
          $(".instructionModalContainer").css('height', 'calc(100vh - 49px)');
          $('.commonModalFooter').css('display', 'none');
          $('.gameContainer').css('height', 'calc(100vh - 49px)');
        }
      }
    });
  }

  startGameOnLoadData() {
    this.progressDone();
    $("#preloaderModal").css('display', 'none');
    this.loaderText = 'game';
    this.characterSpeech = this.gameJsonData.game.Scene;
    $('.showSingle').removeClass('modalFooterActiveBtn');
    $('#showSingle0').addClass('modalFooterActiveBtn');
    $('.targetDiv').hide();
    $('.startGameScreen').hide();
    $('#section0').show();
  }

  playAudio(fileName) {
    for(let i=0; i < this.allCurrentPlayingAudio.length; i++){
      if(this.allCurrentPlayingAudio[i]){
        this.allCurrentPlayingAudio[i].pause();
      }
    }
    let audioFile = this.currentSceneAudios[fileName.split(".")[0]];
    if (audioFile) {
      let introFlag = false;
      if("introduction" == fileName.split(".")[0].trim().toLowerCase()){
        introFlag = true;
      }
      audioFile.addEventListener("timeupdate", () => {
        let currentTime = audioFile.currentTime;
        let totalTime = audioFile.duration;
        this.percent = (currentTime / totalTime) * 100;
        if (this.percent == 100) {
          $('.pauseIconBtn').addClass('displayNone');
          $('.playIconBtn').removeClass('displayNone');
        }
      });
      audioFile.addEventListener("play", () => {
        $('.playIconBtn').addClass('displayNone');
        $('.pauseIconBtn').removeClass('displayNone');
        if(this.volume == 0){
          $(".volumeOn").addClass("displayNone");
          $(".volumeOff").removeClass("displayNone");
        } else {
          $(".volumeOn").removeClass("displayNone");
          $(".volumeOff").addClass("displayNone");
        }
      });
      audioFile.addEventListener("ended", () => {
        if(introFlag){
          this.orientation = window.orientation;
          if (this.orientation == 90 && this.screenWidth < 1000) {
            $('.commonModalFooter').css({"display": "flex"});
            $('.gameContainer').css('height', 'calc(100vh - 68px)');
            $('.instructionModalContainer').css('height', 'calc(100vh - 68px)');
          }
        }
      });
      audioFile.volume = this.volume;
      audioFile.pause(); // For User interaction to browser, because autoplay is disabled by default
      audioFile.play();
      this.currentFeedbackAudio = audioFile;
      this.allCurrentPlayingAudio.push(audioFile);
      $('.playIconBtn').removeClass('displayNone');
      $('.pauseIconBtn').addClass('displayNone');
    } else {
      this.percent = 0;
      $('.playIconBtn').removeClass('displayNone');
      $('.pauseIconBtn').addClass('displayNone');
    }
    $("#preloaderModal").css('display', 'none');
    this.loaderText = 'game';
  }

  restartAudio(fileName) {
    let audioFile = this.currentSceneAudios[fileName.split(".")[0]];
    if (audioFile) {
      audioFile.currentTime = 0;
      audioFile.volume = this.volume;
      this.percent = 0;
      if (audioFile.paused) {
        audioFile.play();
        this.currentFeedbackAudio = audioFile;
        this.percent = 0;
        $('.pauseIconBtn').removeClass('displayNone');
        $('.playIconBtn').addClass('displayNone');

        audioFile.addEventListener("timeupdate", () => {
          let currentTime = audioFile.currentTime;
          let totalTime = audioFile.duration;
          this.percent = (currentTime / totalTime) * 100;
        });
      }
    }
  }

  changeVolume(fileName, val?:any) {
    $(".volumeOff").addClass("displayNone");
    $(".volumeOn").removeClass("displayNone");
    let audioFile = this.currentSceneAudios[fileName.split(".")[0]];
    if (audioFile)
      audioFile.volume = this.volume;
      if (val === "0") {
        $(".volumeOff").removeClass("displayNone");
        $(".volumeOn").addClass("displayNone");
        this.currentFeedbackAudio.muted = true;
      }else{
        this.currentFeedbackAudio.muted = false;
      }

    localStorage.setItem('Volume', this.volume.toLocaleString());
  }

  changeGlobalVolume(val?:any){
    $(".volumeOff").addClass("displayNone");
    $(".volumeOn").removeClass("displayNone");
    localStorage.setItem('Volume', this.volume.toLocaleString());
    if (val === "0") {
      $(".volumeOff").removeClass("displayNone");
      $(".volumeOn").addClass("displayNone");
      this.currentFeedbackAudio.muted = true;
    }else{
      this.currentFeedbackAudio.muted = false;
    }

    this.currentFeedbackAudio.volume = this.volume;
  }

  playGlobalAudio(event){
    this.currentSceneAudios[event.name].play();
    this.currentSceneAudios[event.name].currentTime = 0;
    this.currentSceneAudios[event.name].volume = this.volume;
    this.currentFeedbackAudio = this.currentSceneAudios[event.name];
  }

  playAdvGameGlobalAudio(event){
    event.name.play();
    event.name.currentTime = 0;
    event.name.volume = this.volume;
    this.currentFeedbackAudio = event.name;
  }

  pauseAudio(fileName){
    $('.playIconBtn').removeClass('displayNone');
    $('.pauseIconBtn').addClass('displayNone');
    let audioFile = this.currentSceneAudios[fileName.split(".")[0]];
    if(audioFile){
      audioFile.addEventListener("timeupdate", ()=>{
        let currentTime = audioFile.currentTime;
        let totalTime = audioFile.duration;
        this.percent = (currentTime/totalTime)*100;
        if(this.percent == 100){
          $('.playIconBtn').removeClass('displayNone');
          $('.pauseIconBtn').addClass('displayNone');
        }
      });
      audioFile.pause();
    }
  }

  volumeOn() {
    $(".volumeOn").addClass("displayNone");
    $(".volumeOff").removeClass("displayNone");
    localStorage.setItem('Volume','0');
    localStorage.setItem('prevVolume',this.volume.toString());
    this.volume = 0;
    if (this.currentFeedbackAudio){
      this.currentFeedbackAudio.muted = true;
      this.currentFeedbackAudio.volume = this.volume;
    }
  }

  volumeOff() {
    $(".volumeOff").addClass("displayNone");
    $(".volumeOn").removeClass("displayNone");
    this.volume = localStorage.getItem('prevVolume') ? parseFloat(localStorage.getItem('prevVolume')): 0.5;
    localStorage.setItem('Volume',this.volume.toString());
    if (this.currentFeedbackAudio){
      this.currentFeedbackAudio.muted = false;
      this.currentFeedbackAudio.volume = this.volume;
    }
  }

  getAllAudioFileData(jsonName, game_type) {
    let audioArr = [];
    if (this.gameJsonData && jsonName) {
      let data = this.gameJsonData.game[jsonName];
      if (game_type == 'Basic') {

        if (jsonName == 'information') {
          if (data.introduction.fileName) {
            audioArr.push(data.introduction.fileName);
          }
        } else if (jsonName == 'instruction') {
          let d = this.gameJsonData.game['information'];
          if (d.instruction.fileName) {
            audioArr.push(d.instruction.fileName);
          }
        } else if (jsonName == 'learning') {
          for (let i = 0; i < data.length; i++) {
            audioArr.push(data[i].audio);
          }
        } else {
          if (data.characterSpeech && data.characterSpeech.length > 0) {
            for (let j = 0; j < data.characterSpeech.length; j++) {
              if (data.characterSpeech[j] && data.characterSpeech[j].audioFile && data.characterSpeech[j].audioFile.length > 0) {
                for (let x = 0; x < data.characterSpeech[j].audioFile.length; x++) {
                  if (data.characterSpeech[j].audioFile[x]) {
                    audioArr.push(data.characterSpeech[j].audioFile[x]);
                  }
                }
              }
            }
          }

          if (data.options && data.options.option && data.options.option.length > 0) {
            for (let x = 0; x < data.options.option.length; x++) {
              if (data.options.option[x].audioFile) {
                audioArr.push(data.options.option[x].audioFile);
              }
            }
          }
          audioArr.push('score.mp3');
          audioArr.push('scoreClap.mp3');
        }
      } else if (game_type == 'Advance') {
        //advance

        if (jsonName == 'information') {
          if (data.introduction.fileName) {
            audioArr.push(data.introduction.fileName);
          }
        } else if (jsonName == 'instruction') {
          let inst = this.gameJsonData.game['information'];
          if (inst.instruction.fileName) {
            audioArr.push(inst.instruction.fileName);
          }
        } else if (jsonName == 'learning') {
          for (let i = 0; i < data.length; i++) {
            if (data[i].audio) {
              audioArr.push(data[i].audio);
            }
          }
        } else {
          if (data.characterSpeech && data.characterSpeech.length > 0) {
            for (let j = 0; j < data.characterSpeech.length; j++) {
              if (data.characterSpeech[j] && data.characterSpeech[j].audioFile && data.characterSpeech[j].audioFile.length > 0) {
                for (let x = 0; x < data.characterSpeech[j].audioFile.length; x++) {
                  if (data.characterSpeech[j].audioFile[x]) {
                    audioArr.push(data.characterSpeech[j].audioFile[x]);
                  }
                }
              }
            }
          }

          for (let x = 0; x < data.options.length; x++) {
            if (data.options[x].audioFile) {
              audioArr.push(data.options[x].audioFile);
            }

            let score = data.options[x].score;
            let sc = score.split(':');

            for (let s = 0; s < sc.length; s++) {
              let findSc = this.gameJsonData.game.reactions.responceReactions.find(obj => obj.score == sc[s]);
              if (findSc && findSc.audios && findSc.audios.length > 0) {
                for (let k = 0; k < findSc.audios.length; k++) {
                  let found = audioArr.find(obj => obj ==  findSc.audios[k]);
                  if (findSc.audios[k] && !found) {
                    audioArr.push(findSc.audios[k]);
                  }
                }
              }
            }
          }

          if (data.summaryFeedbacks && data.summaryFeedbacks.length > 0) {
            for (let x = 0; x < data.summaryFeedbacks.length; x++) {
              if (data.summaryFeedbacks[x].audio) {
                audioArr.push(data.summaryFeedbacks[x].audio);
              }
            }
          }

          let reaction = this.gameJsonData.game['reactions'];

          if (reaction && reaction.influenceReactions) {
            if (reaction.influenceReactions.positiveReactions && reaction.influenceReactions.positiveReactions.audios && reaction.influenceReactions.positiveReactions.audios.length > 0) {
              for (let x = 0; x < reaction.influenceReactions.positiveReactions.audios.length; x++) {
                if (reaction.influenceReactions.positiveReactions.audios[x]) {
                  audioArr.push(reaction.influenceReactions.positiveReactions.audios[x]);
                }
              }
            }

            if (reaction.influenceReactions.negativeReactions && reaction.influenceReactions.negativeReactions.audios && reaction.influenceReactions.negativeReactions.audios.length > 0) {
              for (let x = 0; x < reaction.influenceReactions.negativeReactions.audios.length; x++) {
                if (reaction.influenceReactions.negativeReactions.audios[x]) {
                  audioArr.push(reaction.influenceReactions.negativeReactions.audios[x]);
                }
              }
            }
          }

          audioArr.push('scoreBeep.mp3');
          audioArr.push('scoreClap.mp3');
          audioArr.push('scoreType.mp3');
        }
      }
      return audioArr;
    }
  }

  getCharacterImage(character) {
    let url = '';
    let char = character.split('/');
    url = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/characters/" + char[char.length - 1];
    return url;
  }

  viewCharProfile(val) {
    $('.profiletext' + val).show();
  }

  closeCharProfile(val) {
    $('.profiletext' + val).hide();
  }

  closeCourseGamePopup() {
    $('#coursegameInfoModal').modal('hide');
    $('#commCFGMsgsModel').modal('hide');
    this.orientation = window.orientation;
    if (this.orientation == 90 && this.screenWidth < 1000) {
      $('.commonModalFooter').css('display', 'flex');
      $('.instructionModalContainer ').css('height', 'calc(100vh - 66px)');
      $('.mobileSlideHeader').removeClass('headerShow');
    }
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    this.startGameScreen = false;
    this.reviewMode = false;
    this.advGameFinished = false;
    this.isDisplayNotificationDiv = false;
    this.notificationDiv = true;
    this.modalFooterLeftSection = true;
    this.showButton = true;
    this.reviewOutput = [];
    this.reviewStatus = false;
    this.isResourceBtn = false;
    this.addLearnObjText = '';
    this.progressValue = 0;
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
    this.isCertificateGame = false;
    this.reviewOutput = [];
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.parent.postMessage('Close Iframe', '*');
      window.close();
    }
    this.progressValue = 0;

    if (this.choice == 'CertificateCompleted') {
      $("html, body").animate({ scrollTop: 0 }, 600);
    }
    this.link_id = '';
    this.gameId = '';
    this.link_type = '';
    this.guestStatus = '';
  }

  startGame() {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    let num = this.randomNumber;
    this.selectedGameResponse = num.toString();
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    this.orientation = window.orientation;
    if (this.orientation == 90 &&	this.screenWidth < 1000) {
      $('.commonModalFooter').css('display', 'none');
      $(".mobileSlideHeader").removeClass("headerShow");
    }
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
    this.gameFinishedData = undefined;
    if (this.gameJsonData.game.Scene) {
      this.game_type = "Basic";
      let image = new Image();
      if(this.gameJsonData.game.Scene.backGroundImage){
        image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.gameJsonData.game.Scene.backGroundImage;
      } else {
        image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
      }
      this.sceneInfoCharacters = this.gameJsonData.game.information.sceneInfo.characters;
      this.loadScene(0, this.loadedAudios, false, image);
    } else if (this.gameJsonData.game[num]) {
      this.game_type = "Advance";
      let image = new Image();
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameJsonData.game.scenarios.scenario.sceneBg;
      this.loadScene(this.randomNumber, this.loadedAudios, false, image);
    } else {
      this.game_type = "None";
    }

  }

  generateRandomNumber(min, max) {
    let random_number = Math.random() * (max - min) + min;
    return Math.floor(random_number);
  }

  loadScene(num, currentSceneAudios, isGameRestart, bgImage) {
    this.gameAdvUrl = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameLanguage + "/audios/";
    let sceneName = '';
    if(this.game_type == "Basic")
      sceneName = 'Scene';
    else if(this.game_type == "Advance")
      sceneName = num.toString();
    this.loadSpriteAnimations(sceneName, this.nameOfGame, this.game_type, (sceneCharacters)=>{
      this.sceneCharacters = $.extend(this.sceneCharacters, sceneCharacters);
      if(isGameRestart  && this.gameFinishedData)
        this.disableGameResponse = 'false';
      else
        this.disableGameResponse = 'true';

      if (this.game_type == "Basic") {
        this.sceneCharacters.bgImage = bgImage;
        this.characterSpeech = this.gameJsonData.game.Scene;
        this.currentSceneAudios = currentSceneAudios;
        this.loadNextSceneSpriteAnimations('Scene', this.nameOfGame, 'Basic');
      } else if (this.game_type == "Advance") {
        this.sceneCharacters.bgImage = bgImage;
        this.characterSpeech = this.gameJsonData.game[num];
        this.reactions = this.gameJsonData.game.reactions;
        this.influence = this.gameJsonData.game.influencingOptions;
        this.master_feedback = this.gameJsonData.game.mastersFeedback;
        this.currentSceneAudios = currentSceneAudios;
        this.selectedScene = num.toLocaleString();
        this.selectedGameResponse = this.lastSelectedGameResponse.concat(num.toString());
        this.scorePrevData = JSON.parse(JSON.stringify(this.lastScore));
        if(isGameRestart){
          this.influenceCounter = this.dummyinfluenceCounter;
          this.lastThreeResponse = this.dummylastThreeResponse;
        } else {
          this.influenceCounter = 0;
          this.lastThreeResponse = '';
        }
        this.loadNextSceneSpriteAnimations(this.randomNumber.toString(), this.nameOfGame, 'Advance');
      }
      this.isGameRestart = isGameRestart;
      this.notificationDiv = false;
      this.isDisplayNotificationDiv = true;
      this.modalFooterLeftSection = true;
      this.showButton = false;
      this.reviewOutput = [];
      this.reviewMode = false;
      this.advGameFinished = false;
      this.reviewStatus = false;
      this.startGameScreen = true;
      $('.targetDiv').hide();
      $('.showSingle').removeClass('modalFooterActiveBtn');
      $('.startGameScreen').show();
      if (this.TabVideoPlayer)
        this.TabVideoPlayer.nativeElement.pause(); // to pause playing video

      $("#preloaderModal").css('display', 'none');
      this.loaderText = 'game';
    });
  }

  getNextResponse(e) {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    let characterSpeech = this.gameJsonData.game[e.linkTo];
    let image = new Image();
    if(characterSpeech.backGroundImage){
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+characterSpeech.backGroundImage;
    } else {
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
    }
    let files = this.getAllAudioFileData(e.linkTo, this.game_type);
    this.loadGivenAudios(files,(currentSceneAudios)=>{
      this.startNextSceneOnceAudioLoaded(this.gameJsonData.game[e.linkTo],currentSceneAudios,image,e);
    });
  }

  startNextSceneOnceAudioLoaded(scene,sceneAudios,bgImage,e){
    this.gameAdvUrl = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameLanguage + "/audios/";
    this.loadSpriteAnimations(e.linkTo, this.nameOfGame, this.game_type, (sceneCharacters)=>{
      this.characterSpeech = scene;
      this.currentSceneAudios = sceneAudios;
      this.sceneCharacters.bgImage = bgImage;
      this.sceneCharacters = $.extend(this.sceneCharacters, sceneCharacters);
      this.isSpriteAnimationLoaded = false;
      if (this.game_type == "Basic") {
        this.reviewOutput.push(e.reviewArray[0]);
      } else if (this.game_type == "Advance") {
        this.selectedScene = e.linkTo;
        this.isGameRestart = false;
      }
      this.loadNextSceneSpriteAnimations(e.linkTo, this.nameOfGame, this.game_type);
      $("#preloaderModal").css('display', 'none');
      this.loaderText = 'game';
    });
  }

  gameKeyLearningSectionHide(e) {
    this.modalFooterLeftSection = e;
  }

  gameFinished(e) {
    if(this.resConfig[0].Games[0].key_learning && this.resConfig[0].Games[0].key_learning.visible){
      if(this.usrGameCfgData && this.usrGameCfgData.length > 0){
        let ind = this.usrGameCfgData.findIndex(obj=>obj.name == 'key_learning');
        if(ind == -1 || !this.usrGameCfgData[ind].is_completed){
          this.keyLearningBlinkFlag = true;
        }
      }else{
        this.keyLearningBlinkFlag = false;
      }
    }
    this.lastSelectedPath = e['Path'];
    this.gameFinishedData = e;
    this.dummyinfluenceCounter = e['influenceCounter'];
    this.dummylastThreeResponse = e['lastThreeResponse'];
    this.lastSelectedGameResponse = e.Responses;
    this.notificationDiv = true;
    this.isDisplayNotificationDiv = false;
    // this.modalFooterLeftSection = false;
    this.getGameIcons();
    if(e.nextLink)
      this.randomNumber = e.nextLink;
    if (this.isCertificateGame) {
      let obj = {
        user_name: this.userID,
        course_id: this.course_id,
        certificate_id: this.currentCertificate.certificate_id,
        type_flag: 'certificate',
        step_id: this.certificationStep.id,
        sequence_no: 1,
        status: 'Completed',
        attempts: 1,
        score: e.Score,
        path: e.Path,
        choice: e.Choice,
        step_name: this.certificationStep.name,
        step_type: 'Game',
        step_uid: this.certificationStep.step_id,
        version: this.currentCertificate.version,
        stop_time: 0,
        community_id: this.communityID
      };

      this.userStatusService.updatePlayedCertificateSteps(obj).subscribe();
      let data = {
        user_id: this.userID,
        type: 'Game',
        subType: 'Score',
        id: this.certificationStep.id,
        score: e.Score,
        url: this.callbackUrl,
        communityId: this.communityID,
        choice: e.Choice,
        feedbackText: e.feedback_text,
        returnData: this.returnData
      };
      this.userStatusService.returnScoreToCommunity(data).subscribe();
    } else {
      const Obj = {
        user_name: this.userID,
        community_id: this.communityID,
        course_id: this.course_id,
        level: this.publishGameData.level,
        step_id: this.publishGameData.game_id,
        type: "Game",
        score: e.Score,
        path: e.Path,
        choice: e.Choice,
        step_name: this.publishGameData.name,
        attempts: 0
      };
      this.userStatusService.saveCourseTransaction(Obj).subscribe();

      let data = {
        user_id: this.userID,
        type: 'Game',
        subType: 'Score',
        id: this.publishGameData.game_id,
        score: e.Score,
        url: this.callbackUrl,
        communityId: this.communityID,
        choice: e.Choice,
        feedbackText: e.feedback_text,
        returnData: this.returnData
      };

      this.userStatusService.returnScoreToCommunity(data).subscribe();
    }
  }

  getProgressValue(level_id) {
    let data = this.progressData.find(obj => obj.level == level_id);
    if (data) {
      return data.progress;
    } else {
      return 0;
    }
  }

  getNextResponseForAdvance(e) {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    let files = this.getAllAudioFileData(e.linkTo, this.game_type);
    this.loadGivenAudios(files,(currentSceneAudios)=>{
      this.startNextSceneOnceAudioLoaded(this.gameJsonData.game[e.linkTo],currentSceneAudios,this.sceneCharacters.bgImage,e);
    });
  }

  lastScoreSave(e) {
    this.lastScore = e.lastScore;
  }

  restartGame() {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    this.orientation = window.orientation;
    if (this.orientation == 90 && this.screenWidth < 1000) {
      $('.responseBgContainer').css('top', '100%');
      $('.commonModalFooter').css('display', 'none');
      $(".mobileSlideHeader").removeClass("headerShow");
      $('.gameContainer').css('height', '100vh');
    }

    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    if(this.userID && this.communityID && this.gameId){
      this.userStatusService.getUserGameDetails(this.userID, this.communityID, this.gameId).subscribe(det=>{
        if(det.success){
          this.usrGameCfgData = det.data && det.data.details && det.data.details.length > 0 ? det.data.details : [];
        }else{
          this.usrGameCfgData = [];
        }
        let gmObj = {
          user_id: this.userID,
          commId: this.communityID,
          gameId: this.gameId,
          course_id: this.course_id,
          certId: this.currentCertificate
        };

        this.userStatusService.getGameAttempts(gmObj).subscribe(gmAtm=>{
          if(gmAtm.success){
            this.no_of_attempts = gmAtm.data;
          }else{
            this.no_of_attempts = 0;
          }

          if (this.gameJsonData.game.Scene) {
            this.game_type = "Basic";
            let image = new Image();
            if(this.gameJsonData.game.Scene.backGroundImage){
              image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.gameJsonData.game.Scene.backGroundImage;
            } else {
              image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
            }
            let files = this.getAllAudioFileData('Scene', this.game_type);
            this.loadGivenAudios(files,(currentSceneAudios)=>{
              this.loadScene(0, currentSceneAudios, true, image);
            });
          } else if (this.gameJsonData.game[this.randomNumber]) {
            this.game_type = "Advance";
            let image = new Image();
            image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameJsonData.game.scenarios.scenario.sceneBg;
            let files = this.getAllAudioFileData(this.randomNumber, this.game_type);
            this.loadGivenAudios(files,(currentSceneAudios)=>{
              this.loadScene(this.randomNumber, currentSceneAudios, true, image);
            });
          } else {
            this.game_type = "None";
          }
        });
      });
    }else{
      this.usrGameCfgData = [];
      this.no_of_attempts = 0;
      if (this.gameJsonData.game.Scene) {
        this.game_type = "Basic";
        let image = new Image();
        if(this.gameJsonData.game.Scene.backGroundImage){
          image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.gameJsonData.game.Scene.backGroundImage;
        } else {
          image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
        }
        let files = this.getAllAudioFileData('Scene', this.game_type);
        this.loadGivenAudios(files,(currentSceneAudios)=>{
          this.loadScene(0, currentSceneAudios, true, image);
        });
      } else if (this.gameJsonData.game[this.randomNumber]) {
        this.game_type = "Advance";
        let image = new Image();
        image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameJsonData.game.scenarios.scenario.sceneBg;
        let files = this.getAllAudioFileData(this.randomNumber, this.game_type);
        this.loadGivenAudios(files,(currentSceneAudios)=>{
          this.loadScene(this.randomNumber, currentSceneAudios, true, image);
        });
      } else {
        this.game_type = "None";
      }
    }
  }

  showAdvScore(e, val) {
    if(this.volume == 0){
      $(".volumeOn").addClass("displayNone");
      $(".volumeOff").removeClass("displayNone");
    } else {
      $(".volumeOn").removeClass("displayNone");
      $(".volumeOff").addClass("displayNone");
    }
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });

    this.startGameScreen = false;
    $('.startGameScreen').hide();
    this.advGameFinished = true;
    this.notificationDiv = true;
    this.isDisplayNotificationDiv = false;
    $('.showSingle').removeClass('modalFooterActiveBtn');
    $('#showSingle' + val).addClass('modalFooterActiveBtn');
    $('.targetDiv').hide();

    let x = this.lastSelectedPath.substring(0, this.lastSelectedPath.length - 1);
    this.characterSpeechAdv = this.gameJsonData.game[x];

    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
  }

  displayReview(e, val) {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    this.percent = 0;
    if(this.volume == 0){
      $(".volumeOn").addClass("displayNone");
      $(".volumeOff").removeClass("displayNone");
    } else {
      $(".volumeOn").removeClass("displayNone");
      $(".volumeOff").addClass("displayNone");
    }
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
    if (this.reviewOutput.length > 0) {
      $('.targetDiv').hide();
      this.startGameScreen = false;
      $('.showSingle').removeClass('modalFooterActiveBtn');
      $('#showSingle' + val).addClass('modalFooterActiveBtn');
      $('.startGameScreen').hide();
      /*$('#section'+val).show();*/
      this.characterSpeech = this.gameJsonData.game.Scene;
      this.count = 0;
      this.reviewMode = true;
      let iconsImg = [
        '../assets/images/icons/arrow_move_left.svg',
        '../assets/images/icons/down.svg',
        '../assets/images/icons/completedReview.svg',
        '../assets/images/icons/arrow_move_right_orange.svg'
      ];
      let imgcount = 0;
      for(let i=0; i< iconsImg.length; i++){
        let imagea = new Image();
        imagea.src = iconsImg[i];
        imagea.addEventListener('load', () => {
          imgcount++;
          if(iconsImg.length == imgcount){
            $("#preloaderModal").css('display', 'none');
            this.loaderText = 'game';
          }
        });
      }
      let image = new Image();
      if(this.characterSpeech.backGroundImage){
        image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.characterSpeech.backGroundImage;
      } else {
        image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
      }
      this.sceneCharacters.bgImage = image;
    }
  }

  showScore(e, val) {
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    if (this.reviewOutput.length > 0) {
      this.startGameScreen = false;
      $('.showSingle').removeClass('modalFooterActiveBtn');
      $('#showSingle' + val).addClass('modalFooterActiveBtn');
      $('.targetDiv').hide();
      $('.startGameScreen').hide();
      let cnt = this.reviewOutput.length - 1;
      this.characterSpeech = this.gameJsonData.game[this.reviewOutput[cnt].linkTo];
      this.count = cnt;
      this.reviewMode = true;
    }
    this.percent = 0;
    if(this.volume == 0){
      $(".volumeOn").addClass("displayNone");
      $(".volumeOff").removeClass("displayNone");
    } else {
      $(".volumeOn").removeClass("displayNone");
      $(".volumeOff").addClass("displayNone");
    }
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
  }

  showSingle(val) {
    this.loaderText = 'game';
    $("#preloaderModal").css('display', 'block');
    this.startGameScreen = false;
    this.percent = 0;
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    if(this.volume == 0){
      $(".volumeOn").addClass("displayNone");
      $(".volumeOff").removeClass("displayNone");
    } else {
      $(".volumeOn").removeClass("displayNone");
      $(".volumeOff").addClass("displayNone");
    }
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      this.percent = 0;
      this.currentFeedbackAudio.currentTime = 0;
    }
    $('.targetDiv').hide();
    $('.startGameScreen').hide();
    $('.showSingle').removeClass('modalFooterActiveBtn');
    $('#showSingle' + val).addClass('modalFooterActiveBtn');
    $('#section' + val).show();
    $('.targetTabDiv').hide(); // To hide all description in general feedback
    $('#tabSection0').css('display', 'block'); // To show general feedback's first tab open
    $('.showTab').removeClass('activeFeedbackTab'); //to remove active tabs highlighted
    $('#showTab0').addClass('activeFeedbackTab'); // To show general feedback's first active highlighted

    this.orientation = window.orientation;
    if (this.orientation == 90 && this.screenWidth < 1000) {
      $('.instructionModalContainer').css('height', 'calc(100vh - 66px)');
      $(".mobileSlideHeader").removeClass("headerShow");
    }
    if (val == 3) {
      this.saveUserCFGData({flag: 'key_learning'});
      this.keyLearningBlinkFlag = false;
      $( ".tabMenu" ).scrollTop(0);
      this.orientation = window.orientation;
      if (this.orientation == 90) {
        this.generalFeedbackDesktop = false;
        $('.showTabMob0').addClass('activeFeedbackTab'); // To show general feedback's first active highlighted
        $('.targetTabDivMob0').css('display', 'block'); // To show general feedback's first tab open
      } else {
        this.generalFeedbackDesktop = true;
      }
    }

    this.reviewMode = false;
    this.advGameFinished = false;
    this.isDisplayNotificationDiv = false;
    this.notificationDiv = true;


    let files = [];
    if (parseInt(val) == 0) {
      if (this.gameJsonData.game.Scene) {
        files = this.getAllAudioFileData('information', 'Basic');
      } else {
        files = this.getAllAudioFileData('information', 'Advance');
      }
    } else if (parseInt(val) == 1) {
      if (this.gameJsonData.game.Scene) {
        files = this.getAllAudioFileData('instruction', 'Basic');
      } else {
        files = this.getAllAudioFileData('instruction', 'Advance');
      }
    } else if (parseInt(val) == 3) {
      if (this.gameJsonData.game.Scene) {
        files = this.getAllAudioFileData('learning', 'Basic');
      } else {
        files = this.getAllAudioFileData('learning', 'Advance');
      }
    }
    let count = 0;
    if(files.length == 0) {
      this.getGameIcons();
      $("#preloaderModal").css('display', 'none');
      this.loaderText = 'game';
    }
    this.currentSceneAudios = {};
    this.loadGivenAudios(files,(currentAudios)=> {
      this.getGameIcons();
      $("#preloaderModal").css('display', 'none');
      this.loaderText = 'game';
      this.currentSceneAudios = $.extend(this.currentSceneAudios, currentAudios);
      if (parseInt(val) == 0) {
        if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Audio && this.resConfig[0].Audio.Introduction){
          if (this.charactersDetails.introduction.fileType == 'audio') {
            this.playAudio(this.charactersDetails.introduction.fileName)
          } else {
            if(document.readyState === "complete") {
              // Fully loaded!
              if (this.TabVideoPlayer){
                this.TabVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                document.getElementById("userInteractBtn").click();
                this.TabVideoPlayer.nativeElement.play();
              }
            }else{
              $(document).ready(function(){
                if (this.TabVideoPlayer){
                  this.TabVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.TabVideoPlayer.nativeElement.play();
                }
              });
            }
          }
          //this.startGameOnLoadData();
        }
      } else if (parseInt(val) == 1) {
        if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Audio && this.resConfig[0].Audio.Instruction){
          if (this.charactersDetails.instruction.fileType == 'audio') {
            this.playAudio(this.charactersDetails.instruction.fileName)
          } else {
            if(document.readyState === "complete") {
              // Fully loaded!
              if (this.TabVideoPlayer){
                this.TabVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                document.getElementById("userInteractBtn").click();
                this.TabVideoPlayer.nativeElement.play();
              }
            }else{
              $(document).ready(function(){
                if (this.TabVideoPlayer){
                  this.TabVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.TabVideoPlayer.nativeElement.play();
                }
              });
            }
          }
          //this.startGameOnLoadData();
        }
      } else if (parseInt(val) == 3) {
        if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Audio && this.resConfig[0].Audio.key_learning){
          if (this.general_feedback[0].fileType == 'audio') {
            this.playAudio(this.general_feedback[0].audio);
          } else {
            if(document.readyState === "complete") {
              // Fully loaded!
              if ($("#feedbackVideoTab0").get(0)) {
                $("#feedbackVideoTab0").get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
                document.getElementById("userInteractBtn").click();
                $("#feedbackVideoTab0").get(0).play();
                $("#feedbackVideoTab0").get(0).currentTime = 0;
              }
            }else{
              $(document).ready(function(){
                if ($("#feedbackVideoTab0").get(0)) {
                  $("#feedbackVideoTab0").get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  $("#feedbackVideoTab0").get(0).play();
                  $("#feedbackVideoTab0").get(0).currentTime = 0;
                }
              });
            }
          }
        }
      }
    })
    /*----------------------------------------------------------------------------------------------------------*/
  }

  reviewChoiceToUser(e) {
    this.count = e.count;
    this.count++;
    //this.characterSpeech = this.gameJsonData.game[e.linkTo];
    if (e.flag == 'NEXT') {
      this.count = e.count;
      this.count++;
      this.characterSpeech = this.gameJsonData.game[e.linkTo];
      if (this.characterSpeech.endNode == "true" || this.characterSpeech.endNode == true) {
        this.reviewStatus = true;
        this.orientation = window.orientation;
        if (this.orientation == 90 && this.screenWidth < 1000) {
          $('.responseBgContainer').css('top', '0%');
          $('.responseBgContainer').css('height', '100%');
        }
      } else {
        this.reviewStatus = false;
      }
    } else if (e.flag == 'PREV') {
      this.count = e.count > 0 ? e.count - 1 : 0;
      let prev = this.reviewOutput[this.count].title;
      this.characterSpeech = this.gameJsonData.game[prev];
    }
    let image = new Image();
    if(this.characterSpeech.backGroundImage){
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/"+this.characterSpeech.backGroundImage;
    } else {
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/background.png";
    }
    this.sceneCharacters.bgImage = image;
  }

  closeAlertMsgsModel(){
    this.guestStatus = "";
    $('#alertMsgsModel').modal('hide');
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.parent.postMessage('Close Iframe', '*');
      window.close();
    }
  }

  getSrtFile(fileName){
    return (this.videoPath +''+fileName.split('.')[0]+'.vtt');
  }

  getEngSrtFile(fileName){
    return (this.engVideoPath +''+fileName.split('.')[0]+'.vtt');
  }

  showFeedbackTab(val, feed) {
    $('.manualVideo').each(function () {
      $(this).get(0).pause();
    });
    $('.targetTabDiv').hide();
    $('.showTab').removeClass('activeFeedbackTab');
    $('#tabSection' + val).show();
    this.percent = 0;
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
      $('.playIconBtn').removeClass('displayNone');
      $('.pauseIconBtn').addClass('displayNone');
      this.currentFeedbackAudio.currentTime = 0;
      this.percent = 0;
    }
    if (this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Audio && this.resConfig[0].Audio.key_learning) {
      if (feed.fileType == 'audio') {
        this.playAudio(feed.audio);
      } else if (feed.fileType == 'video') {
        if (document.readyState === "complete") {
          // Fully loaded!
          $("#feedbackVideoTab" + val).get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
          document.getElementById("userInteractBtn").click();
          $("#feedbackVideoTab" + val).get(0).play();
          $("#feedbackVideoTab" + val).get(0).currentTime = 0;
        } else {
          $(document).ready(function () {
            $("#feedbackVideoTab" + val).get(0).pause(); // For User interaction to browser, because autoplay is disabled by default
            document.getElementById("userInteractBtn").click();
            $("#feedbackVideoTab" + val).get(0).play();
            $("#feedbackVideoTab" + val).get(0).currentTime = 0;
          });
        }
      }
    }
    $('#showTab' + val).addClass('activeFeedbackTab');
  }


  /************************************************* Assessment Functions ***********************************************************/

  viewAssessment(step) {
    this.isSurveyGiven = false;
    this.step_id = step.id;
    this.step_unique_id = step.step_id;
    this.minimumPassScore = step.minscore;
    this.currentStep = step.name;
    this.currentStepType = step.type;
    let lang_id = 'English';
    this.userStatusService.getAssessmentById(step.id, lang_id)
      .subscribe(res => {
        if (res.success) {
          if (res.data) {
            this.index = 0;
            this.assessment = res.data.assessment;
            this.questionsArr = res.data.questions;
            this.finalAswers = [];
            if (this.questionsArr.length == 1 && this.assessment.type == 'Assessment') {
              this.nextAssessmentBtn = false;
              this.submitAssessmentBtn = true;
            } else if (this.assessment.type == 'Assessment') {
              this.nextAssessmentBtn = false;
              this.submitAssessmentBtn = false;
            } else {
              this.nextAssessmentBtn = false;
              this.submitAssessmentBtn = false;
            }
            // this.assessment.type == 'Assessment' ? this.nextAssessmentBtn = true : this.nextAssessmentBtn = false;
            $('#assessmentModal').modal('show');
            $('.instrBtn').addClass('activeInstrBtn');
            this.progressScore = 0;
          }
        }
      });
  }

  selectCorrectAns(e, val, question_id) {
    this.noAnswers = false;
    this.isShowAssErr = false;
    this.invalidAnswers = false;
    if (e.target.checked) {
      let flag = true;
      var remove = 0;
      for (let i = 0; i < this.finalAswers.length; i++) {
        if (this.finalAswers[i].question_id == question_id) {
          flag = false;
          remove = i;
          break;
        }
      }
      if (flag) {
        var answer_arr = [];
        answer_arr.push(val);
        var ansArray = {
          "question_id": question_id,
          "answer_arr": answer_arr
        };
        this.finalAswers.push(ansArray);
      } else {
        this.finalAswers.splice(remove, 1);
        var answer_arr = [];
        answer_arr.push(val);
        var ansArray = {
          "question_id": question_id,
          "answer_arr": answer_arr
        };
        this.finalAswers.push(ansArray);
      }
    }
    //this.getAssessmentProgressVal();
  }

  selectMultiCorrectAns(e, val, question_id) {
    this.noAnswers = false;
    this.isShowAssErr = false;
    this.invalidAnswers = false;
    var flag = true;
    var remove = 0;
    for (let i = 0; i < this.finalAswers.length; i++) {
      if (this.finalAswers[i].question_id == question_id) {
        flag = false;
        remove = i;
        break;
      }
    }

    if (e.target.checked) {
      if (flag) {
        var answer_arr = [];
        answer_arr.push(val);
        var ansArray = {
          "question_id": question_id,
          "answer_arr": answer_arr
        };
        this.finalAswers.push(ansArray);
      } else {
        var answer_arr = [];
        answer_arr = this.finalAswers[remove].answer_arr;
        this.finalAswers.splice(remove, 1);

        answer_arr.push(val);
        var ansArray = {
          "question_id": question_id,
          "answer_arr": answer_arr
        };
        this.finalAswers.push(ansArray);
      }
    }
    if (!e.target.checked) {
      var index = this.finalAswers[remove].answer_arr.map(obj => obj).indexOf(val);
      if (index != -1) {
        this.finalAswers[remove].answer_arr.splice(index, 1);
      }
    }

    //this.getAssessmentProgressVal();
  }

  addCorrectAnsForSurvey(val, question_id, ans) {
    const testValue = val.data ? val.data.trim() : val.data;
    let ans1 = ans ? ans.trim() : ans;
    if(ans1 && ans1.length > 0){
      if (testValue && testValue.length > 0) {
        this.noAnswers = false;
        this.isShowAssErr = false;
        this.invalidAnswers = false;
        var flag = true;
        var remove = 0;
        for (let i = 0; i < this.finalAswers.length; i++) {
          if (this.finalAswers[i].question_id == question_id) {
            flag = false;
            remove = i;
            break;
          }
        }
        if (flag) {
          var answer_arr = [];
          answer_arr.push(testValue);
          var ansArray = {
            "question_id": question_id,
            "answer_arr": answer_arr
          };
          this.finalAswers.push(ansArray);

        } else {
          var answer_arr = [];
          this.finalAswers[remove].answer_arr = [];
          this.finalAswers.splice(remove, 1);
          answer_arr.push(testValue);
          var ansArray = {
            "question_id": question_id,
            "answer_arr": answer_arr
          };
          this.finalAswers.push(ansArray);
        }
      }
    }else{
      // this.invalidAnswers = true;
      // this.isShowAssErr = true;
      // let remove = this.finalAswers.findIndex(obj => obj.question_id == question_id);
      // if (remove != -1) {
      //   this.finalAswers[remove].answer_arr = [];
      // }
      let removedIndex = this.finalAswers.findIndex(obj => obj.question_id === question_id);
      if (removedIndex != -1) {
        this.finalAswers.splice(removedIndex, 1);
      }
    }
  }

  assessmentQuestion(assessmentQuestionForm) {
    this.finalResultArray = this.finalAswers;
    let language_id = 'English';
    let finalLength = this.questionsArr.length;
    for(let j=0; j< this.questionsArr.length; j++){
      if(this.questionsArr[j].option_type == "Textbox"){
        finalLength--;
      }
    }
    if (this.finalAswers.length >= finalLength) {
      let flag = true;

      for (let s = 0; s < this.finalAswers.length; s++) {
        if (this.finalAswers[s].answer_arr && this.finalAswers[s].answer_arr.length == 0) {
          flag = false;
          break;
        }
      }

      if (flag) {
        this.invalidAnswers = false;
        this.isShowAssErr = false;
        if (this.assessment.type == 'Assessment' && !this.minimumPassScore) {
          this.minimumPassScore = this.assessment.passing_score.toString();
        }

        let Obj = {
          finalAnsArr: this.finalAswers,
          assessment_id: this.assessment.assessment_id,
          user_name: this.userID,
          passing_score: this.minimumPassScore,
          lang: language_id,
          certificate_id: this.certificate_id,
          course_id: this.course_id,
          step_uid: this.step_unique_id,
          certificate_version: this.currentCertificate.version,
          community_id: this.communityID
        };


        this.userStatusService.saveAssessmentForUser(Obj)
          .subscribe(result => {
            if(result.success){
              this.validationMsg = result.statusCode;
              this.passing_score = result.passing_score;
              this.finalScore = result.score;
              // $('#assessmentModal').modal('hide');
              // $('#successModal').modal('show');
              this.resultContainer = true;
              this.submitAssessmentBtn = false;
              $('.submitAssessmentBtn').css('display', 'none');
              $('.assessmentContainerWrapper').css('display', 'none');
              //assessmentQuestionForm.reset();
              let stepObj;
              if (this.assessment.type == 'Assessment') {
                this.progressScore = Math.round((parseInt(this.finalScore) / this.assessment.total_score) * 100);
                if (this.finalScore >= this.passing_score) {

                  stepObj = {
                    user_name: this.userID,
                    course_id: this.course_id,
                    certificate_id: this.certificate_id,
                    type_flag: 'certificate',
                    step_id: this.certificationStep.id,
                    sequence_no: 1,
                    status: 'Completed',
                    attempts: 1,
                    score: this.finalScore,
                    step_name: this.assessment.name,
                    step_type: this.assessment.type,
                    step_uid: this.step_unique_id,
                    version: this.currentCertificate.version,
                    stop_time: 0,
                    community_id: this.communityID
                  };
                } else {
                  stepObj = {
                    user_name: this.userID,
                    course_id: this.course_id,
                    certificate_id: this.certificate_id,
                    type_flag: 'certificate',
                    step_id: this.certificationStep.id,
                    sequence_no: 1,
                    status: 'Inprogress',
                    attempts: 1,
                    score: this.finalScore,
                    step_name: this.assessment.name,
                    step_type: this.assessment.type,
                    step_uid: this.step_unique_id,
                    version: this.currentCertificate.version,
                    stop_time: 0,
                    community_id: this.communityID
                  };
                }

                let data = {
                  user_id: this.userID,
                  type: 'Assessment',
                  subType: 'Score',
                  id: this.certificationStep.id,
                  score: this.finalScore,
                  url: this.callbackUrl,
                  communityId: this.communityID,
                  returnData: this.returnData
                };
                this.userStatusService.returnScoreToCommunity(data).subscribe();
              } else {
                this.isSurveyGiven = true;
                $('.startAssessmentBtn').css('display', 'none');
                stepObj = {
                  user_name: this.userID,
                  course_id: this.course_id,
                  certificate_id: this.certificate_id,
                  type_flag: 'certificate',
                  step_id: this.certificationStep.id,
                  sequence_no: 1,
                  status: 'Completed',
                  attempts: 1,
                  score: 0,
                  step_name: this.assessment.name,
                  step_type: this.assessment.type,
                  step_uid: this.step_unique_id,
                  version: this.currentCertificate.version,
                  stop_time: 0,
                  community_id: this.communityID
                };
              }
              this.userStatusService.updatePlayedCertificateSteps(stepObj).subscribe(res => {
                this.checkInit = 1;
                this.played_steps = res.transaction.played_steps;
                //this.getRespectiveInstruction(res.transaction, this.currentCertificate);

                //Level wise progress call
                const progressObj = {
                  course_id: this.course_id,
                  username: this.userID,
                  community_id: this.communityID,
                  language_id: language_id
                };

                this.userStatusService.getCourseByIdWithLevelWiseProgress(progressObj)
                  .subscribe(progressData => {
                    if (progressData.success) {
                      this.progressData = progressData.progressData;
                      this.getProgressValue('Certifications');
                    }
                  });
              });
            }
          });

      } else {
        this.noAnswers = true;
        this.isShowAssErr = true;
        this.invalidAnswers = false;
      }
    } else {
      this.noAnswers = true;
      this.isShowAssErr = true;
      this.invalidAnswers = false;
    }
  }

  closeAssessmentModel(assessmentQuestionForm) {
    $('.instrToolTipText').removeClass('hideInstrToolTip');
    $('input:checkbox').prop('checked', false);
    $('input:radio').prop('checked', false);
    assessmentQuestionForm.reset();
    this.finalAswers = [];
    this.answers = [];
    $('#assessmentModal').modal('hide');
    this.noAnswers = false;
    this.isShowAssErr = false;
    this.invalidAnswers = false;
    $('.instructionModalContainer').css('display', 'block');
    $('.startAssessmentBtn').css('display', 'block');
    $('.assessmentContainerWrapper').css('display', 'none');
    $('.submitAssessmentBtn').css('display', 'none');
    $('.nextAssessmentBtn').css('display', 'none');
    $('.resultContainer').css('display', 'none');
    $('.assessmentProgressWrapper').css('display', 'none');
    this.submitAssessmentBtn = false;
    this.nextAssessmentBtn = false;
    this.resultContainer = false;
    this.progressScore = 0;
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.parent.postMessage('Close Iframe', '*');
      window.close();
    }
    if (this.choice == 'CertificateCompleted') {
      $("html, body").animate({ scrollTop: 0 }, 600);
    }
  }

  getAssessmentProgressVal() {
    let result = 0;
    if (this.finalAswers.length > 0 && this.questionsArr.length > 0) {
      var played = 0;
      for (let j = 0; j < this.finalAswers.length; j++) {
        if (this.finalAswers[j].answer_arr && this.finalAswers[j].answer_arr.length > 0) {
          played = played + 1;
        }
      }
      if (played > 0) {
        result = (played / this.questionsArr.length) * 100;
      }

    }
    return result;
  }

  startAssessmentClick(assessmentQuestionForm) {
    $('.instructionModalContainer').css('display', 'none');
    $('.startAssessmentBtn').css('display', 'none');
    $('.resultContainer').css('display', 'none');
    $('.assessmentContainerWrapper').css('display', 'block');
    $('.submitAssessmentBtn').css('display', 'block');
    $('.nextAssessmentBtn').css('display', 'block');
    $('.assessmentProgressWrapper').css('display', 'block');
    $('.instrBtn').removeClass('activeInstrBtn');
    this.minimumPassScore = '';
    this.index = 0;
    this.resultContainer = false;
    this.progressData = [];
    this.finalAswers = [];
    this.noAnswers = false;
    this.isShowAssErr = false;
    this.answers = [];
    $('input:checkbox').prop('checked', false);
    $('input:radio').prop('checked', false);
    assessmentQuestionForm.reset();
    if (this.questionsArr.length == 1 && this.assessment.type == 'Assessment') {
      this.nextAssessmentBtn = false;
      this.submitAssessmentBtn = true;
    } else if (this.assessment.type == 'Assessment') {
      this.nextAssessmentBtn = true;
      this.submitAssessmentBtn = false;
    } else {
      this.nextAssessmentBtn = false;
      this.submitAssessmentBtn = false;
    }
  }

  isAnswerGiven() {
    if (this.finalAswers[this.index] && this.finalAswers[this.index].answer_arr.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  assessmentNextQue() {
    $('input:checkbox').prop('checked', false);
    $('input:radio').prop('checked', false);
    if (this.finalAswers.length < this.questionsArr.length) {
      this.index++;
    }
    if (this.finalAswers.length < this.questionsArr.length - 1) {
      this.nextAssessmentBtn = true;
    } else {
      this.nextAssessmentBtn = false;
      this.submitAssessmentBtn = true;
    }
  }

  instrClick() {
    if (this.currentFeedbackAudio && this.currentFeedbackAudio.paused == false) {
      this.currentFeedbackAudio.pause();
    }
    if (this.assessment.type == 'Assessment') {
      $('.startAssessmentBtn').css('display', 'block');
      /*if (this.assessment.total_score.toString() == this.finalScore) {
       $('.startAssessmentBtn').css('display', 'none');
       } else {
       $('.startAssessmentBtn').css('display', 'block');
       }*/
    } else if (this.assessment.type == 'Survey') {
      if (this.isSurveyGiven) {
        $('.startAssessmentBtn').css('display', 'none');
      } else {
        $('.startAssessmentBtn').css('display', 'block');
      }
    }
    $('.instructionModalContainer').css('display', 'block');
    $('.assessmentContainerWrapper').css('display', 'none');
    $('.submitAssessmentBtn').css('display', 'none');
    $('.nextAssessmentBtn').css('display', 'none');
    $('.resultContainer').css('display', 'none');
    $('.assessmentProgressWrapper').css('display', 'none');
    $('.instrBtn').addClass('activeInstrBtn');
    // $('.error').css('display', 'none');
  }
  /************************************************* Assessment Functions ***********************************************************/

  /************************************************* Video Functions ***********************************************************/
  closeVideoPopup() {
    $('.instrToolTipText').removeClass('hideInstrToolTip');

    this.duration = 0;
    if (this.selectedVideo.type == 'Local') {
      this.videoplayer.nativeElement.pause();
      this.duration = this.videoplayer.nativeElement.duration;
      this.videoTrack1.nativeElement.src = '';
      this.videoTrack2.nativeElement.src = '';
      this.saveCertVimeoTrans();
    } else {
      if (!this.youtubePlayerFlag) {
        if (this.certificatePlayer) {
          this.certificatePlayer.pauseVideo();
          this.currentTime = this.certificatePlayer.getCurrentTime();//.toLocaleString();
          this.duration = this.certificatePlayer.getDuration();
          this.saveCertVimeoTrans();
        }
        this.certificateVideoId = '';
      } else if (!this.vimeoPlayerFlag) {
        this.vimeoCertPlayer.pause();
        var x = this.vimeoCertPlayer.getCurrentTime().then((data) => {
          this.currentTime = data;
          var y = this.vimeoCertPlayer.getDuration().then((durationData) => {
            this.duration = durationData;
            this.saveCertVimeoTrans();
            this.vimeoCertPlayer.destroy();
          });
        });
      }
    }
    this.certPlayerFlag = false;
  }

  saveCertVimeoTrans() {
    let per = 0;
    this.duration = Math.round(this.duration);
    this.currentTime = parseInt(this.currentTime);
    if(this.currentTime > 0 && this.duration > 0){
      if(this.currentTime <= this.duration){
        per = ((this.currentTime / this.duration) * 100);
      }else{
        this.currentTime = this.duration;
        per = ((this.currentTime / this.duration) * 100);
      }
    }else{
      per = 0;
    }
    let obj = {
      user_name: this.userID,
      course_id: this.course_id,
      certificate_id: this.certificate_id,
      type_flag: 'certificate',
      step_id: this.certificationStep.id,
      sequence_no: 1,
      status: 'Completed',
      attempts: 1,
      score: 0,
      step_name: this.certificationStep.name,
      step_type: this.certificationStep.type,
      step_uid: this.certificationStep.step_id,
      version: this.currentCertificate.version,
      stop_time: this.currentTime,
      completed_percent: Math.round(per),
      community_id: this.communityID
    };

    this.userStatusService.updatePlayedCertificateSteps(obj).subscribe(res => {
      this.checkInit = 1;
      this.played_steps = res.transaction.played_steps;
      if(this.redirectUrl != ''){
        location.replace(this.redirectUrl);
      }else{
        window.parent.postMessage('Close Iframe', '*');
        window.close();
      }
    });

    this.videoSource = '';
    $('#videoInfoModal').modal('hide');
  }

  playVideo(step) {
    this.certPlayerFlag = true;
    this.step_id = step.id;
    this.step_unique_id = step.step_id;
    let videoId = '';
    this.currentStep = step.name;
    this.currentStepType = step.type;
    const obj = {
      user_name: this.userID,
      course_id: this.course_id,
      certificate_id: this.certificate_id,
      type_flag: 'certificate',
      step_id: step.id,
      sequence_no: 1,
      status: 'Inprogress',
      attempts: 0,
      score: 70,
      step_name: step.name,
      step_type: step.type,
      step_uid: step.step_uid
    };
    let lang_id = 'English';
    let lang_name = 'English';
    this.userStatusService.getVideoById(step.id, lang_id, lang_name).subscribe(res => {
      videoId = res.data.url;
      this.selectedVideo = res.data;
      this.currentTime = 0;
      this.duration = 0;
      if (this.selectedVideo.type == 'Local') {
        this.youtubePlayerFlag = true;
        this.vimeoPlayerFlag = true;
        this.userStatusService.getCertificateTransaction(this.course_id, this.certificate_id, this.userID).subscribe(res => {
          if (res.data && res.data.played_steps.length > 0) {
            const picked = res.data.played_steps.find(steps => steps.step_uid === step.step_uid);

            if (picked && picked.stop_time) {
              setTimeout(() => {
                if(document.readyState === "complete") {
                  // Fully loaded!
                  this.videoplayer.nativeElement.currentTime = picked.stop_time;
                  this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.videoplayer.nativeElement.play();
                }else{
                  $(document).ready(function(){
                    this.videoplayer.nativeElement.currentTime = picked.stop_time;
                    this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                    document.getElementById("userInteractBtn").click();
                    this.videoplayer.nativeElement.play();
                  });
                }
              }, 100);
            }else{
              setTimeout(() => {
                if(document.readyState === "complete") {
                  // Fully loaded!
                  this.videoplayer.nativeElement.currentTime = 0;
                  this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.videoplayer.nativeElement.play();
                }else{
                  $(document).ready(function(){
                    this.videoplayer.nativeElement.currentTime = 0;
                    this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                    document.getElementById("userInteractBtn").click();
                    this.videoplayer.nativeElement.play();
                  });
                }
              }, 100);
            }
          }else{
            setTimeout(() => {
              if(document.readyState === "complete") {
                // Fully loaded!
                this.videoplayer.nativeElement.currentTime = 0;
                this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                document.getElementById("userInteractBtn").click();
                this.videoplayer.nativeElement.play();
              }else{
                $(document).ready(function(){
                  this.videoplayer.nativeElement.currentTime = 0;
                  this.videoplayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.videoplayer.nativeElement.play();
                });
              }
            }, 100);
          }
          this.videoSource = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosPath+'' + videoId;
          this.videoSrtPath = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosSrtFilesPath+''+lang_name+''+this.selectedVideo.srtpath + '.vtt';
          this.videoEngSrtPath = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosSrtFilesPath+'English'+this.selectedVideo.srtpath + '.vtt';
        });
        $('#videoInfoModal').modal('show');
      } else if (this.selectedVideo.type == 'Online') {

        this.videoSrtPath = "";
        this.videoEngSrtPath = "";
        this.videoSource = this.selectedVideo.url;
        this.checkVideoType(this.videoSource);

        $('#videoInfoModal').modal('show');
        this.userStatusService.getCertificateTransaction(this.course_id, this.certificate_id, this.userID).subscribe(res => {
          if (res.data.played_steps.length > 0) {
            const picked = res.data.played_steps.find(steps => steps.step_uid === step.step_uid);
            if (picked && picked.stop_time) {
              this.currentTime = picked.stop_time;
            } else {
              this.currentTime = 0;
            }
            if (!this.youtubePlayerFlag) {
              if (this.certificatePlayer) {

                this.certificateVideoId = this.validateYTBUrl(this.videoSource);
                this.certificatePlayer.loadVideoById(this.certificateVideoId, this.currentTime);
                this.certificatePlayer.seekTo(this.currentTime, true);
              } else {
                this.certificateVideoId = this.validateYTBUrl(this.videoSource);
              }
            } else if (!this.vimeoPlayerFlag) {
              this.certificateVideoId = this.videoSource.split("/").pop();
              this.options = {
                id: this.videoSource.split("/").pop(),
                width: 760,
                height: 400
              };
              this.vimeoCertPlayer = new Player(this.vimeoCertVideo.nativeElement, this.options);
              this.vimeoCertPlayer.pause();
              this.vimeoCertPlayer.setCurrentTime(this.currentTime).then(function (seconds) {
              });
              if(document.readyState === "complete") {
                // Fully loaded!
                document.getElementById("userInteractBtn").click();
                this.vimeoCertPlayer.play();
              }else{
                $(document).ready(function(){
                  document.getElementById("userInteractBtn").click();
                  this.vimeoCertPlayer.play();
                });
              }
            }
          } else {
            if (!this.youtubePlayerFlag) {
              if (this.certificatePlayer) {
                this.certificateVideoId = this.validateYTBUrl(this.videoSource);
                this.certificatePlayer.loadVideoById(this.certificateVideoId, this.currentTime);
              } else {
                this.certificateVideoId = this.validateYTBUrl(this.videoSource);
              }
            } else if (!this.vimeoPlayerFlag) {
              this.certificateVideoId = this.videoSource.split("/").pop();
              this.options = {
                id: this.videoSource.split("/").pop(),
                width: 760,
                height: 400
              };
              this.vimeoCertPlayer = new Player(this.vimeoCertVideo.nativeElement, this.options);
            }
          }
        });
      }
    });
  }

  checkVideoType(videoUrl) {
    if (videoUrl.includes("vimeo")) {
      this.vimeoPlayerFlag = false;
      this.youtubePlayerFlag = true;
    }
    else if (videoUrl.includes("youtube") || videoUrl.includes("youtu.be")) {
      this.youtubePlayerFlag = false;
      this.vimeoPlayerFlag = true;
    }
  }

  validateYTBUrl(videourl) {
    var Id;
    if (videourl.includes("v=")) {
      Id = videourl.split('v=')[1];
      var ampersandPosition = Id.indexOf('&');
      if (ampersandPosition != -1) {
        Id = Id.substring(0, ampersandPosition);
      }
    } else {
      Id = videourl.split("/").pop();
    }
    return Id;
  }

  saveCertificatePlayer(player) {
    if (this.certPlayerFlag) {
      this.certificatePlayer = player;
      this.certificatePlayer.loadVideoById(this.validateYTBUrl(this.videoSource), this.currentTime);
    }
  }

  setLocalVideoCurrentTime(data) {
    this.currentTime = data.target.currentTime;
  }

  closeCourseVideoPopup() {
    this.duration = 0;
    if (this.selectedVideo.type == 'Local') {
      this.courseVideoPlayer.nativeElement.pause();
      this.duration = this.courseVideoPlayer.nativeElement.duration;
      this.crsVideoTrack1.nativeElement.src = '';
      this.crsVideoTrack2.nativeElement.src = '';
      this.saveCourseVideoTrans();
    } else if (!this.youtubePlayerFlag) {
      if (this.player) {
        this.player.pauseVideo();
        this.currentTime = this.player.getCurrentTime();
        this.duration = this.player.getDuration();
        this.saveCourseVideoTrans();
      }
      this.courseVideoId = '';
    } else if (!this.vimeoPlayerFlag) {
      this.vimeoPlayer.pause();
      var x = this.vimeoPlayer.getCurrentTime().then((data) => {
        this.currentTime = data;
        var y = this.vimeoPlayer.getDuration().then((durationData) => {
          this.duration = durationData;
          this.saveCourseVideoTrans();
          this.vimeoPlayer.destroy();
        });
      });

      if (this.choice == 'CertificateCompleted') {
        $("html, body").animate({ scrollTop: 0 }, 600);
      }
    }
    this.coursePlayerFlag = false;
  }

  saveCourseVideoTrans() {
    let per = 0;
    this.duration = Math.round(this.duration);
    this.currentTime = parseInt(this.currentTime);
    if(this.currentTime > 0 && this.duration > 0){
      if(this.currentTime <= this.duration){
        per = ((this.currentTime / this.duration) * 100);
      }else{
        this.currentTime = this.duration;
        per = ((this.currentTime / this.duration) * 100);
      }
    }else{
      per = 0;
    }
    const Obj = {
      user_name: this.userID,
      community_id: this.communityID,
      course_id: this.course_id,
      level: "Instructional",
      step_id: this.currentPlayingStep.video_id,
      type: "Video",
      isIntroVideo: this.currentPlayingStep.intro_video,
      score: 0,
      step_name: this.currentPlayingStep.name,
      attempts: 0,
      stop_time: this.currentTime,
      completed_percent: Math.round(per)
    };
    this.userStatusService.saveCourseTransaction(Obj).subscribe(result => {
      if(this.redirectUrl != ''){
        location.replace(this.redirectUrl);
      }else{
        window.parent.postMessage('Close Iframe', '*');
        window.close();
      }
    });
    this.videoSource = '';
    this.videoSrtPath = '';
    this.videoEngSrtPath = '';
    $('#coursevideoInfoModal').modal('hide');
  }

  savePlayer(player) {
    if (this.coursePlayerFlag) {
      this.player = player;
      this.player.loadVideoById(this.validateYTBUrl(this.videoSource), this.currentTime);
    }
  }

  playCourseVideo(video_id) {
    this.coursePlayerFlag = true;
    let videoId = '';
    let lang_id = 'English';
    let lang_name = 'English';
    this.userStatusService.getVideoById(video_id, lang_id, lang_name).subscribe(res => {
      if (res.success) {
        let videoData = res.data.fileData;
        videoId = res.data.url;
        this.selectedVideo = res.data;
        this.currentPlayingStep = res.data;
        this.currentTime = 0;
        this.duration = 0;
        if (this.selectedVideo.type == 'Local') {
          this.youtubePlayerFlag = true;
          this.vimeoPlayerFlag = true;
          this.currentTime = 0;
          this.userStatusService.courseTransactionByLevelId(this.course_id, 'Instructional', this.userID).subscribe(res => {
            if (res.data && res.data.steps_arr.length > 0) {
              const picked = res.data.steps_arr.find(steps => steps.step_id === video_id);
              if (picked && picked.stop_time) {
                setTimeout(() => {
                  if(document.readyState === "complete") {
                    // Fully loaded!
                    this.courseVideoPlayer.nativeElement.currentTime = picked.stop_time;
                    this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                    document.getElementById("userInteractBtn").click();
                    this.courseVideoPlayer.nativeElement.play();
                  }else{
                    $(document).ready(function(){
                      this.courseVideoPlayer.nativeElement.currentTime = picked.stop_time;
                      this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                      document.getElementById("userInteractBtn").click();
                      this.courseVideoPlayer.nativeElement.play();
                    });
                  }
                }, 100);
              }else{
                setTimeout(() => {
                  if(document.readyState === "complete") {
                    // Fully loaded!
                    this.courseVideoPlayer.nativeElement.currentTime = 0;
                    this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                    document.getElementById("userInteractBtn").click();
                    this.courseVideoPlayer.nativeElement.play();
                  }else{
                    $(document).ready(function(){
                      this.courseVideoPlayer.nativeElement.currentTime = 0;
                      this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                      document.getElementById("userInteractBtn").click();
                      this.courseVideoPlayer.nativeElement.play();
                    });
                  }
                }, 100);
              }
            }else{
              setTimeout(() => {
                if(document.readyState === "complete") {
                  // Fully loaded!
                  this.courseVideoPlayer.nativeElement.currentTime = 0;
                  this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                  document.getElementById("userInteractBtn").click();
                  this.courseVideoPlayer.nativeElement.play();
                }else{
                  $(document).ready(function(){
                    this.courseVideoPlayer.nativeElement.currentTime = 0;
                    this.courseVideoPlayer.nativeElement.pause(); // For User interaction to browser, because autoplay is disabled by default
                    document.getElementById("userInteractBtn").click();
                    this.courseVideoPlayer.nativeElement.play();
                  });
                }
              }, 100);
            }
            this.videoSource = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosPath+'' + videoId;
            this.videoSrtPath = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosSrtFilesPath+''+lang_name+''+this.selectedVideo.srtpath + '.vtt';
            this.videoEngSrtPath = Configuration.S3_BucketObjectURL+''+ Configuration.S3_VideosSrtFilesPath+'English'+this.selectedVideo.srtpath + '.vtt';
          });
          $('#coursevideoInfoModal').modal('show');
        } else if (this.selectedVideo.type == 'Online') {
          this.videoSrtPath = '';
          this.videoEngSrtPath = '';
          this.videoSource = this.selectedVideo.url;
          //Getting Video url Type
          this.checkVideoType(this.videoSource);

          this.userStatusService.courseTransactionByLevelId(this.course_id, 'Instructional', this.userID).subscribe(res => {
            if (res.data && res.data.steps_arr.length > 0) {
              const picked = res.data.steps_arr.find(steps => steps.step_id === video_id);
              if (picked && picked.stop_time) {
                this.currentTime = picked.stop_time;
              } else {
                this.currentTime = 0;
              }
              if (!this.youtubePlayerFlag) {
                if (this.player) {

                  this.courseVideoId = this.validateYTBUrl(this.videoSource);
                  this.player.loadVideoById(this.courseVideoId);
                  this.player.seekTo(this.currentTime, true);
                } else {
                  this.courseVideoId = this.validateYTBUrl(this.videoSource);
                }
              } else if (!this.vimeoPlayerFlag) {
                this.courseVideoId = this.videoSource.split("/").pop();
                this.options = {
                  id: this.videoSource.split("/").pop(),
                  width: 760,
                  height: 400,
                  loop: true
                };
                this.vimeoPlayer = new Player(this.vimeoVideo.nativeElement, this.options);
                this.vimeoPlayer.pause();
                this.vimeoPlayer.setCurrentTime(this.currentTime).then(function (seconds) {
                });
                if(document.readyState === "complete") {
                  // Fully loaded!
                  document.getElementById("userInteractBtn").click();
                  this.vimeoPlayer.play();
                }else{
                  $(document).ready(function(){
                    document.getElementById("userInteractBtn").click();
                    this.vimeoPlayer.play();
                  });
                }
              }
            } else {
              if (!this.youtubePlayerFlag) {
                if (this.player) {
                  this.courseVideoId = this.validateYTBUrl(this.videoSource);
                  this.player.loadVideoById(this.courseVideoId, this.currentTime);
                } else {
                  this.courseVideoId = this.validateYTBUrl(this.videoSource);
                }
              } else if (!this.vimeoPlayerFlag) {
                this.courseVideoId = this.videoSource.split("/").pop();
                this.options = {
                  id: this.videoSource.split("/").pop(),
                  width: 760,
                  height: 400,
                  loop: true
                };
                this.vimeoPlayer = new Player(this.vimeoVideo.nativeElement, this.options);
              }
            }
          });
          $('#coursevideoInfoModal').modal('show');
        }
      }
    });
  }
  /************************************************* Video Functions ***********************************************************/

  progressStart(){
    this.progressValue = 1;
    this.visibleProgess = true;
    this.progressInc();
  }
  progressInc(){
    setTimeout(() => {
      if(this.progressValue + (2) < 98){
        this.progressValue = this.progressValue + (2);
        this.progressInc();
      }
    }, 500);
  }
  progressDone(){
    setTimeout(() => {
      this.progressValue = 100;
      this.visibleProgess = false;
    }, 100);
  }

  gameResponseDisable(e) {
    this.notificationDiv = e.response;
    this.isDisplayNotificationDiv = !this.notificationDiv;
  }

  vidEnded(){
    this.orientation = window.orientation;
    if (this.orientation == 90 && this.screenWidth < 1000) {
      $('.commonModalFooter').css({"display": "flex"});
      $('.gameContainer').css('height', 'calc(100vh - 68px)');
      $('.instructionModalContainer').css('height', 'calc(100vh - 68px)');
    }
  }

  closeShowAssErr(){
    console.log("click");
    this.isShowAssErr = false;
  }



  loadSpriteAnimations(scene, gameName, game_type, callback){
    this.loaderText = 'sprite';
    let characters = [];
    for(let i=0; i < this.gameJsonData.game[scene].characterSpeech.length;i++) {
      if(this.gameJsonData.game[scene].characterSpeech[i].tone !="Absent" && this.gameJsonData.game[scene].characterSpeech[i].name !="Narrator"){
        for(let j=0; j < this.gameJsonData.game[scene].characterSpeech[i].expression.length; j++) {
          characters.push(this.gameJsonData.game[scene].characterSpeech[i].name+'_'+this.gameJsonData.game[scene].characterSpeech[i].expression[j]);
        }
      }
    }
    if(game_type == "Advance"){
      for(let i=0; i< this.gameJsonData.game.reactions.responceReactions.length; i++){
        characters.push(this.gameJsonData.game.information.sceneInfo.characters[0].charName+'_'+this.gameJsonData.game.reactions.responceReactions[i].expression);
      }
      characters.push(this.gameJsonData.game.information.sceneInfo.characters[0].charName+'_'+this.gameJsonData.game.reactions.influenceReactions.positiveReactions.expression);
      characters.push(this.gameJsonData.game.information.sceneInfo.characters[0].charName+'_'+this.gameJsonData.game.reactions.influenceReactions.negativeReactions.expression);
    }

    let sceneCharacters = {};
    let count  = 0;
    characters = characters.filter((v, i, z) => z.indexOf(v) === i);
    for(let i=0; i< characters.length;i++){
      let image = new Image();
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/characters/" + characters[i] + ".png";
      sceneCharacters[characters[i]] = image;
      image.addEventListener('load', (obj) => {
        count++;
        if(count == characters.length){
          callback(sceneCharacters);
        }
      });

      image.addEventListener('error', (obj) => {
        const currentUser1 = JSON.parse(localStorage.getItem('currentUser'));
        let details = {
          userName: this.userID,
          screenResolution: this.GlobalService.getCurrentScreenResolution(),
          browserName: this.GlobalService.getCurrentBrowserName(),
          gameName: this.nameOfGame,
          gameFolderName: this.nameOfGameFolder,
          imgSrc: image.src,
          gameLanguage: this.gameLanguage,
          failCount: 1
        };

        this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});

        console.log("----------------------Failed----------------------");
        console.log(image.src);
        let missingImage = new Image();
        missingImage.src = image.src;
        missingImage.addEventListener('load', () => {
          count++;
          if(count == characters.length){
            callback(sceneCharacters);
          }
        });
        missingImage.addEventListener('error', (obj) => {
          details.imgSrc = missingImage.src;
          details.failCount = 2;

          this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});

          console.log("----------------------Failed----------------------");
          console.log(missingImage.src);
          let missingImage1 = new Image();
          missingImage1.src = missingImage.src;
          missingImage1.addEventListener('load', () => {
            count++;
            if(count == characters.length){
              callback(sceneCharacters);
            }
          });
          missingImage1.addEventListener('error', (obj) => {
            details.imgSrc = missingImage1.src;
            details.failCount = 3;

            this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});
            this.httpErrorService.showError(this.gameTranTitle['SERVER_HTTP_ALERT.SPRITE_ANIMATIONS']+' '+this.nameOfGameFolder);
          })
        })
      })
    }
  }

  loadNextSceneSpriteAnimations(scene, gameName, game_type){
    let characters = [];
    let nextScenes = [];
    if(game_type == 'Basic'){
      for(let i=0; i < this.gameJsonData.game[scene].options.option.length; i++) {
        let newScene = this.gameJsonData.game[this.gameJsonData.game[scene].options.option[i].id];
        nextScenes.push(this.gameJsonData.game[scene].options.option[i].id);
        for(let j=0; j < newScene.characterSpeech.length;j++) {
          if(newScene.characterSpeech[j].tone !="Absent" && newScene.characterSpeech[j].name !="Narrator"){
            for(let k=0; k < newScene.characterSpeech[j].expression.length; k++) {
              characters.push(newScene.characterSpeech[j].name+'_'+newScene.characterSpeech[j].expression[k]);
            }
          }
        }
      }
    }else if(game_type == 'Advance'){
      for(let i=0; i < this.gameJsonData.game[scene].options.length; i++) {
        let id = this.gameJsonData.game[scene].options[i].id;
        let newScene1 = this.gameJsonData.game[id+'1'];
        if(newScene1){
          nextScenes.push(id+'1');
          for(let j=0; j < newScene1.characterSpeech.length;j++) {
            for(let k=0; k < newScene1.characterSpeech[j].expression.length; k++) {
              characters.push(newScene1.characterSpeech[j].name+'_'+newScene1.characterSpeech[j].expression[k]);
            }
          }
        }
        let newScene2 = this.gameJsonData.game[id+'2'];
        if(newScene2){
          nextScenes.push(id+'2');
          for(let j=0; j < newScene2.characterSpeech.length;j++) {
            for(let k=0; k < newScene2.characterSpeech[j].expression.length; k++) {
              characters.push(newScene2.characterSpeech[j].name+'_'+newScene2.characterSpeech[j].expression[k]);
            }
          }
        }
      }
    }
    let totalFiles = [];
    for(let i=0; i< nextScenes.length; i++){
      let files = this.getAllAudioFileData(nextScenes[i], this.game_type);
      totalFiles = totalFiles.concat(files);
      console.log(files);
    }
    if(totalFiles.length == 0){
      if (this.gameJsonData.game.Scene) {
        totalFiles = this.getAllAudioFileData('learning', 'Basic');
      } else {
        totalFiles = this.getAllAudioFileData('learning', 'Advance');
      }
    }
    if(characters.length == 0){
      this.loadGivenAudios(totalFiles,(currentAudios)=>{
        console.log("---------------------------All Files Loaded---------------------------------------");
      });
    }
    let sceneCharacters = {};
    let count  = 0;
    characters = characters.filter((v, i, z) => z.indexOf(v) === i);
    for(let i=0; i< characters.length;i++){
      this.loaderText = 'sprite';
      let image = new Image();
      image.src = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/characters/" + characters[i] + ".png";
      sceneCharacters[characters[i]] = image;
      if(image.complete){
        count++;
        if(count == characters.length){
          this.loadGivenAudios(totalFiles,(currentAudios)=>{
            console.log("---------------------------All Files Loaded---------------------------------------");
          });
          this.isSpriteAnimationLoaded = true;
          let bgImage = this.sceneCharacters.bgImage;
          this.preloadNextSceneSprites = sceneCharacters;
          this.preloadNextSceneSprites.bgImage = bgImage;
        }
      }else {
        image.addEventListener('load', (obj) => {
          count++;
          if(count == characters.length){
            this.loadGivenAudios(totalFiles,(currentAudios)=>{
              console.log("---------------------------All Files Loaded---------------------------------------");
            });
            this.isSpriteAnimationLoaded = true;
            let bgImage = this.sceneCharacters.bgImage;
            this.preloadNextSceneSprites = sceneCharacters;
            this.preloadNextSceneSprites.bgImage = bgImage;
          }
        });

        image.addEventListener('error', (obj) => {
          const currentUser1 = JSON.parse(localStorage.getItem('currentUser'));
          let details = {
            userName: this.userID,
            screenResolution: this.GlobalService.getCurrentScreenResolution(),
            browserName: this.GlobalService.getCurrentBrowserName(),
            gameName: this.nameOfGame,
            gameFolderName: this.nameOfGameFolder,
            imgSrc: image.src,
            gameLanguage: this.gameLanguage,
            failCount: 1
          };

          this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});
          console.log("----------------------Failed----------------------");
          console.log(image.src);
          let missingImage = new Image();
          missingImage.src = image.src;
          missingImage.addEventListener('load', () => {
            count++;
            if(count == characters.length){
              this.loadGivenAudios(totalFiles,(currentAudios)=>{
                console.log("---------------------------All Files Loaded---------------------------------------");
              });
              this.isSpriteAnimationLoaded = true;
              let bgImage = this.sceneCharacters.bgImage;
              this.preloadNextSceneSprites = sceneCharacters;
              this.preloadNextSceneSprites.bgImage = bgImage;
            }
          });
          missingImage.addEventListener('error', (obj) => {
            details.imgSrc = missingImage.src;
            details.failCount = 2;

            this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});

            console.log("----------------------Failed----------------------");
            console.log(missingImage.src);
            let missingImage1 = new Image();
            missingImage1.src = missingImage.src;
            missingImage1.addEventListener('load', () => {
              count++;
              if(count == characters.length){
                this.loadGivenAudios(totalFiles,(currentAudios)=>{
                  console.log("---------------------------All Files Loaded---------------------------------------");
                });
                this.isSpriteAnimationLoaded = true;
                let bgImage = this.sceneCharacters.bgImage;
                this.preloadNextSceneSprites = sceneCharacters;
                this.preloadNextSceneSprites.bgImage = bgImage;
              }
            });
            missingImage1.addEventListener('error', (obj) => {
              details.imgSrc = missingImage1.src;
              details.failCount = 3;

              this.GlobalService.saveUsersGameSpriteImgsFailedToLoad(details).subscribe(res => {});
              this.httpErrorService.showError(this.gameTranTitle['SERVER_HTTP_ALERT.SPRITE_ANIMATIONS']+' '+this.nameOfGameFolder);
            })
          })
        });
      }
    }
  }

  loadGivenAudios(audioFiles, callback){
    this.loaderText = 'audio';
    let count = 0;
    let totalAudios = audioFiles.length;
    let currentSceneAudios = {};
    for (let i = 0; i < audioFiles.length; i++) {
      if (audioFiles[i].split('.')[1] == 'mp3') {
        let audioSource = '';
        let name = audioFiles[i].split(".");
        let scoreAudios = name[0].includes('score');

        if (scoreAudios) {
          audioSource = Configuration.S3_BucketObjectURL+''+ Configuration.S3_AudiosPath+ '' + audioFiles[i];
        } else {
          if(this.gameLanguage !== 'English'){
            let found = this.languageAudioList.find(audio => audio == audioFiles[i]);
            if(found){
              audioSource = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/" + this.gameLanguage + "/audios/" + audioFiles[i];
            } else {
              let found = this.englishAudioList.find(audio => audio == audioFiles[i]);
              if(found)
                audioSource = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/English/audios/" + audioFiles[i];
            }
          } else {
            let found = this.englishAudioList.find(audio => audio == audioFiles[i]);
            if(found){
              audioSource = Configuration.S3_BucketObjectURL+''+Configuration.S3_PublishedGames + "" + this.nameOfGame + "/English/audios/" + audioFiles[i];
            }
          }
        }

        let loadAudFlag = true;
        if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Audio && this.resConfig[0].Audio.Introduction){
          let audNm = audioFiles[i] && audioFiles[i].length > 0 ? audioFiles[i].split(".")[0] : '';
          if(audNm && audNm == 'Introduction' && !this.resConfig[0].Audio.Introduction){
            loadAudFlag = false;
          } else if(audNm && audNm == 'Instruction' && !this.resConfig[0].Audio.Instruction){
            loadAudFlag = false;
          }else if(audNm && audNm.includes('gf_') && !this.resConfig[0].Audio.key_learning){
            loadAudFlag = false;
          }
        }

        if(loadAudFlag){
          let audio = new Audio();
          /*audio.preload = "auto";
          audio.autoplay  = false;
          audio.src = audioSource;
          audio.load();
          let that = this;
          audio.addEventListener('progress', function _listener() {
            audio.removeEventListener('progress',_listener);
            count++;
            currentSceneAudios[name[0]] = audio;
            if (totalAudios == count) {
              callback(currentSceneAudios);
            }
          });
          audio.addEventListener('error', function _listener() {
            audio.removeEventListener('error',_listener);
            count++;
            if (totalAudios == count) {
              callback(currentSceneAudios);
            }
          });*/

          if (audioSource) {
            let mediaSource = new MediaSource();
            //audio.crossOrigin="anonymous";
            audio.src = URL.createObjectURL(mediaSource);
            mediaSource.addEventListener('sourceopen', () => {
              URL.revokeObjectURL(audio.src);
              let mime = 'audio/mpeg';
              let sourceBuffer = mediaSource.addSourceBuffer(mime);

              fetch(encodeURI(audioSource))
                .then(function (response) {
                  return response.arrayBuffer();
                })
                .then(function (arrayBuffer) {
                  sourceBuffer.addEventListener('updateend', function (e) {
                    if (!sourceBuffer.updating && mediaSource.readyState === 'open') {
                      mediaSource.endOfStream();
                      count++;
                      currentSceneAudios[name[0]] = audio;
                      if (totalAudios == count) {
                        callback(currentSceneAudios);
                      }
                      // audio.play();
                    }
                  });
                  sourceBuffer.appendBuffer(arrayBuffer);
                })
                .catch(function (error) {
                  console.log("error...", error);
                  console.log(".....", audioFiles[i]);
                  count++;
                  if (totalAudios == count) {
                    callback(currentSceneAudios);
                  }
                });
            });
          } else {
            count++;
            if (totalAudios == count) {
              callback(currentSceneAudios);
            }
          }
        }else{
          count++;
          if (totalAudios == count) {
            callback(currentSceneAudios);
          }
        }
      } else {  /* -- If mp4 -- */
        count++;
        if (totalAudios == count) {
          callback(currentSceneAudios);
        }
      }
    }
  }

  getLoadTextMsg(e){
    this.loaderText = e.flag != '' ? e.flag : 'game' ;
  }

  saveUserCFGData(e){
    if(this.userID && this.communityID && this.gameId) {
      let validFlag = false;
      let obj;

      if (e.flag == 'feedback_text') {
        validFlag = true;
        obj = {
          user_id : this.userID,
          commId : this.communityID,
          gameId : this.gameId,
          flag : e.flag,
          data : e.text
        };
      }else if(e.flag == 'key_learning'){
        this.addExtraPoints = 0;

        if(this.resConfig[0].Games[0].key_learning && this.resConfig[0].Games[0].key_learning.visible){
          if(this.usrGameCfgData && this.usrGameCfgData.length > 0){
            let ind = this.usrGameCfgData.findIndex(obj=>obj.name == 'key_learning');
            if(ind == -1 || !this.usrGameCfgData[ind].is_completed){
              this.addExtraPoints = this.resConfig[0].Games[0].key_learning.add_points;
              validFlag = true;
            }
          }else{
            this.addExtraPoints = this.resConfig[0].Games[0].key_learning.add_points;
            validFlag = true;
          }
        }

        obj = {
          user_id : this.userID,
          commId : this.communityID,
          gameId : this.gameId,
          flag : e.flag,
          points : this.addExtraPoints
        };
      }else if(e.flag == 'try_other_answer'){
        validFlag = true;
        obj = {
          user_id : this.userID,
          commId : this.communityID,
          gameId : this.gameId,
          flag : e.flag
        };
      }

      if(validFlag) {
        this.userStatusService.saveUserGameDetails(obj).subscribe(res => {
          if (res.success) {
            let useCfg = res.data && res.data.details && res.data.details.length > 0 ? res.data.details : [];
            if(e.flag == 'key_learning'){
              this.usrGameCfgData = JSON.parse(JSON.stringify(useCfg));

              let data = {
                user_id: this.userID,
                type: 'Game',
                subType: 'Key Learning',
                id: this.gameId,
                score: '' + this.addExtraPoints,
                url: this.callbackUrl,
                communityId: this.communityID,
                returnData: this.returnData
              };

              this.userStatusService.returnScoreToCommunity(data).subscribe();
            }
          }
        });
      }
    }
  }

  confirmGameClosePopup(){
    $("#preloader").css('display', 'block');
    this.tryOtherAnsCFGFlag = false;
    this.keyLearningCFGFlag = false;
    let no_of_attempts = 0;
    let usrGameCfgData = [];
    let keyLearnFlag = false;
    let tryAnsFlag = false;
    if(this.userID && this.communityID && this.gameId){
      this.userStatusService.getUserGameDetails(this.userID, this.communityID, this.gameId).subscribe(det=>{
        if(det.success){
          usrGameCfgData = det.data && det.data.details && det.data.details.length > 0 ? det.data.details : [];
        }else{
          usrGameCfgData = [];
        }

        let gmObj = {
          user_id: this.userID,
          commId: this.communityID,
          gameId: this.gameId,
          course_id: this.course_id,
          certId: this.currentCertificate
        };

        this.userStatusService.getGameAttempts(gmObj).subscribe(gmAtm=>{
          if(gmAtm.success){
            no_of_attempts = gmAtm.data;
          }else{
            no_of_attempts = 0;
          }

          if(this.resConfig && this.resConfig.length > 0 && this.resConfig[0].Games && this.resConfig[0].Games.length > 0){
            //TryOtherAns
            if(this.resConfig[0].Games[0].try_other_answer && this.resConfig[0].Games[0].try_other_answer.visible && no_of_attempts == 1){
              if(usrGameCfgData && usrGameCfgData.length > 0){
                let ind = usrGameCfgData.findIndex(obj=>obj.name == 'try_other_answer');
                if(ind == -1){
                  tryAnsFlag = true;
                }
              }else{
                tryAnsFlag = true;
              }
            }

            //key_learning
            if(this.resConfig[0].Games[0].key_learning && this.resConfig[0].Games[0].key_learning.visible && no_of_attempts >= 1){
              if(usrGameCfgData && usrGameCfgData.length > 0){
                let ind = usrGameCfgData.findIndex(obj=>obj.name == 'key_learning');
                if(ind == -1 || !usrGameCfgData[ind].is_completed){
                  keyLearnFlag = true;
                }
              }else{
                keyLearnFlag = true;
              }
            }
          }

          if(tryAnsFlag && keyLearnFlag){
            this.tryOtherAnsCFGFlag = true;
            this.keyLearningCFGFlag = true;
            this.keyLearningBlinkFlag = true;
            this.saveUserCFGData(({flag: 'try_other_answer'}));
            $('#commCFGMsgsModel').modal('show');
            $("#preloader").css('display', 'none');
          }else if(tryAnsFlag){
            this.tryOtherAnsCFGFlag = true;
            this.keyLearningCFGFlag = false;
            this.saveUserCFGData(({flag: 'try_other_answer'}));
            $('#commCFGMsgsModel').modal('show');
            $("#preloader").css('display', 'none');
          }else if(keyLearnFlag){
            this.tryOtherAnsCFGFlag = false;
            this.keyLearningCFGFlag = true;
            this.keyLearningBlinkFlag = true;
            $('#commCFGMsgsModel').modal('show');
            $("#preloader").css('display', 'none');
          }else{
            this.tryOtherAnsCFGFlag = false;
            this.keyLearningCFGFlag = false;
            $("#preloader").css('display', 'none');
            this.closeCourseGamePopup();
          }
        });
      });
    }else{
      this.tryOtherAnsCFGFlag = false;
      this.keyLearningCFGFlag = false;
      $("#preloader").css('display', 'none');
      this.closeCourseGamePopup();
    }
  }

  closeCommCFGMsgsModel(){
    $('#commCFGMsgsModel').modal('hide');
    this.tryOtherAnsCFGFlag = false;
    this.keyLearningCFGFlag = false;
  }

  isDisplayNotificationDivText(e){
    this.isDisplayNotificationDiv = e.flag;
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/content-launcher/content-launcher.component.ts